import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  VERSION
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SearchDialogComponent } from "../table-list/Searchdialog/SearchDialoag.component";
//import { CampDialogComponent } from "../table-list/Campdialog/CampDialoag.component";
//import { GeneralDialoag } from "../table-list/Generaldialog/GeneralDialoag.component";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { registrationService } from "./Services/registration.service";
import { NgForm } from "@angular/forms";

import { DatePipe } from "@angular/common";
import { AuthService } from "app/auth/auth.service";

import { HttpClient } from "@angular/common/http";
import { SiteloaderComponent } from "app/auth/siteloader/siteloader.component";
import { Subject, Subscription, config, of } from "rxjs";
import { ActivatedRoute, Params } from "@angular/router";
import { PatientdocsComponent } from "./patientdocs/patientdocs.component";
import { ConfirmationBoxComponent } from "app/dashboard/confirmation-box/confirmation-box.component";
import { Title } from "@angular/platform-browser";
import { Phoneno_confirmation_dialogComponent } from "./phoneno_confirmation_dialog/phoneno_confirmation_dialog.component";
import { PatientFieldsModel } from "./Models/patient_mendatory_fields_config.model";
import { Webcam_photoComponent } from "./webcam_photo/webcam_photo.component";
import { LanguageService } from 'app/shared/language.service';
import { TranslateService } from '@ngx-translate/core';
//import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from "ngx-qrcode2";
import { BillingserviceService } from "app/billing/billingService.service";
import { FormControl } from '@angular/forms';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { interval, Observable } from 'rxjs';
import { CountryMasterComponent } from "app/masters/location-master/country-master/country-master.component";
import { StateMasterComponent } from "app/masters/location-master/state-master/state-master.component";
import { DistrictMasterComponent } from "app/masters/location-master/district-master/district-master.component";
import { CityMasterComponent } from "app/masters/location-master/city-master/city-master.component";
import { AreaMasterComponent } from "app/masters/location-master/area-master/area-master.component";
import { DynamicHelpListComponent } from "app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { IPDService } from "app/ipd/Services/ipdServices.service";
import { takeUntil } from "rxjs/operators";
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { AadhaarprofileModel, ABHAIDModel } from "./Models/abhaidmodel";
import { MatStepper } from "@angular/material/stepper";
import { EncryptionService } from "./rsa-encryption.service";
import jsPDF from "jspdf";
import { MatTabChangeEvent } from "@angular/material/tabs";

@Component({
  // encapsulation: ViewEncapsulation.None,
  selector: "app-table-list",
  templateUrl: "./table-list.component.html",
  styleUrls: ["./table-list.component.scss"],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class TableListComponent implements OnInit {
  destroytableList$: Subject<boolean> = new Subject<boolean>();
  Title = 'Angular ' + VERSION.major;
  //elementType = NgxQrcodeElementTypes.URL;
  //correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  user_validated = "";
  isFavorite: boolean = false;
  selectedLanguage: any;
  checkgender: boolean = true;
  controlfocusout: boolean = false;
  // barcode setting
  patient_mendatory_fields: PatientFieldsModel[] = [];
  public screenPermissionobj: any = {};
  newintial: any;
  intialGender: any;
  familyUHID: number;
  intialtype: any;
  @ViewChild("defaultauto", { static: false }) private defaultautoRef: ElementRef;
  @ViewChild("autofax", { static: false }) private autofaxRef: ElementRef;
  @ViewChild('Oldphotos') el: ElementRef;
  paramsubscription: Subscription;
  filterstate: any;
  filtercountry1: any;
  filterstate1: any;
  vipselected = false;
  disableselected = false;
  addresschecked = false;
  isReadOnly: boolean = true;
  index: number;
  opdService: any;
  ocupationCtrl: FormControl;
  filteredOcupationArray: Observable<any[]>;
  ShowNationalityName: any;
  NationalityCtrl: FormControl;
  filteredNationalityArray: Observable<any[]>;
  filtercountry: any;
  GroupCtrl: FormControl;
  filteredGroupArray: Observable<any[]>;
  ShowPartyName: any;
  PartyCtrl: FormControl;
  filteredPartyArray: Observable<any[]>;
  ReferedbyCtrl: FormControl;
  filteredReferedbyArray: Observable<any[]>;
  selectedValue: string = 'Aadhaar Card No.';
  selectedName: any;
  phonedata: any;
  filterTerm: any;
  filterTerm1: any;
  filterTerm2: any;
  filterTerm3: any;
  filterTerm4: any;
  filterTerm5: any;
  TempId: any;
  animal: string;
  checked: boolean = false;
  childevent: boolean = true;
  checkedToggle(event) {
    this.checked = event;
  }
  constructor(
    public dialog: MatDialog,
    public opdvisitService: OpdVisitService,
    public dashboardService: DashboardService,
    public registerService: registrationService,
    public datePipe: DatePipe,
    public authService: AuthService,
    public http: HttpClient,
    public route: ActivatedRoute,
    public title: Title,
    public langservice: LanguageService,
    public translate: TranslateService,
    public billingservice: BillingserviceService,
    public branchMatserService: BranchMatserService,
    public ipdService: IPDService,
    private rsaEncryptionService: EncryptionService
  ) {

    // this.value="Name:"+ this.opdvisitService.patientdetails.initial+''+this.opdvisitService.patientdetails.firstName+''+this.opdvisitService.patientdetails.lastName;
    this.translate.addLangs(['en', 'fr', 'hi', 'ar']);
    if (this.langservice.setlang) {
      this.translate.setDefaultLang(this.langservice.setlang);
      this.selectedLanguage = this.langservice.setlang;
    }
    else {
      this.translate.setDefaultLang('en');
    }
    this.opdvisitService.getinitials();

    this.registerService.assignValue();
  }



  onCountryChange(event: any) {

    if (event.dialCode != null || event.dialCode != undefined) {
      this.opdvisitService.patientdetails.m_CountryCode = '+' + event.dialCode;
    } else {
      this.opdvisitService.patientdetails.m_CountryCode = '+91';
    }

  }

  switchLang(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
  }

  clearintialform() {
    this.newintial = '';
    this.intialGender = '';
    this.intialtype = '';
  }

  // auto filter for occupation 
  occupationControll() {

    this.ocupationCtrl = new FormControl();
    this.filteredOcupationArray = this.ocupationCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filteroccupationfunction(cat) : this.opdvisitService.GetOccupation.slice())
      );
  }

  filteroccupationfunction(name: string) {
    if (name != null && name != undefined) {
      const filtervalue = name.toLowerCase();
      return this.opdvisitService.GetOccupation.filter(op =>
        op.popupDescription.toLowerCase().indexOf(filtervalue) === 0);
    }
  }

  getoccupationobj(e: any) {
    var val = e.option.value;
    console.log(val)
    this.opdvisitService.ShowOccupationName = val.popupDescription;
    this.opdvisitService.patientdetails.fkOccupationId = val.pkPopupId;
  }



  nationalControll() {

    this.NationalityCtrl = new FormControl();
    this.filteredNationalityArray = this.NationalityCtrl.valueChanges
      .pipe(
        startWith(''),
        map(party => party ? this.filternationalfunction(party) : this.opdvisitService.GetNationality.slice())
      );
  }
  // filter natioanl wise
  filternationalfunction(name: string) {
    if (name != null && name != undefined) {
      return this.opdvisitService.GetNationality.filter(party =>
        party.popupDescription.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }
  }

  getNatinalobj(e: any) {
    this.selectedName = e.option.value;
    var valId = e.option.id;
    this.opdvisitService.check_nationality(this.selectedName);
    this.opdvisitService.patientdetails.fkNationalityId = valId;
  }


  groupControll() {
    // ShowGroupName:any;
    // GroupCtrl: FormControl;
    // filteredGroupArray: Observable<any[]>;
    this.GroupCtrl = new FormControl();
    this.filteredGroupArray = this.GroupCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filtergroupfunction(cat) : this.opdvisitService.GroupList.slice())
      );
  }

  filtergroupfunction(name: string) {
    if (name != null && name != undefined) {
      return this.opdvisitService.GroupList.filter(gp =>
        gp.popupDescription.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }
  }

  getgroupobj(e: any) {
    var val = e.option.value;
    console.log(val)
    this.opdvisitService.ShowGroupName = val.popupDescription;
    this.opdvisitService.patientdetails.fkGroupId = val.pkPopupId;
  }


  partyControll() {

    this.PartyCtrl = new FormControl();
    this.filteredPartyArray = this.PartyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterpartyfunction(cat) : this.opdvisitService.partymaster.slice())
      );
  }

  filterpartyfunction(name: string) {
    if (name != null && name != undefined) {
      return this.opdvisitService.partymaster.filter(party =>
        party.partyName.toLowerCase().indexOf(name.toLowerCase()) === 0);
    }
  }

  getPartyobj(e: any) {
    let val = e.option.value;
    let partyID = e.option.id;
    console.log(val)
    // this = val.partyName;
    this.opdvisitService.patientdetails.fkPartyId = partyID;
  }

  referedbyControll() {
    this.ReferedbyCtrl = new FormControl();
    this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterReferedbyfunction(cat) : this.opdvisitService.personmaster.slice())
      );
  }
  newPersonArray: any = [];
  filterReferedbyfunction(name: string) {
    if (name != null && name != undefined) {
      const filterValue = name.toLowerCase();
      const returndata = this.opdvisitService.personmaster.filter(country =>
        country.personName?.toLowerCase().indexOf(filterValue) === 0);
      if (returndata.length == 0 && name.length >= 3) {
        this.opdvisitService.getpersonMasterSpecific('REGISTRATION', name).pipe(takeUntil(this.destroytableList$)).subscribe((x: any) => {
          this.newPersonArray = [];
          this.newPersonArray = x;
          this.filteredReferedbyArray = this.ReferedbyCtrl.valueChanges
            .pipe(
              startWith(''),
              map(cat => this.newPersonArray.slice())
            );
        })
      } else {
        return returndata;
      }
    }
  }

  getreferedbyobj(e: any) {
    var val = e.option.value;
    this.opdvisitService.patientdetails.referredBy = val.personName;
    this.opdvisitService.patientdetails.fkReferredbyId = val.pkPersonId;
  }




  onFileChange(event) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      if (event.target.files.length > 0) {
        const filedata = event.target.files[0];
        const formData = new FormData();
        formData.append('file', filedata);
        formData.append('patientid', this.opdvisitService.patientdetails.pkRegId?.toString());
        this.dashboardService.subscriptions = this.registerService.uploaddocument(formData).pipe(takeUntil(this.destroytableList$))
          .subscribe(
            data => this.successfileupload(data), err => this.failedfileupload(err)
          )
      }
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }

  }

  successfileupload(data) {
    this.opdvisitService.get_old_photo();
    this.dashboardService.openSnackBar(" Uploaded Successfully", "OK");


  }
  failedfileupload(err) {
    this.dashboardService.openSnackBar(" Upload Failed", "OK");
  }

  setreferrtype() {
    // console.log ("pid " + personid);
    this.opdvisitService.reffertypeid = this.opdvisitService.patientdetails.fkReferredbyId;
  }
  getmrnolabel(label: string) {
    // console.log("label " + label);
    // console.log("label no is "+ this.patient_mendatory_fields[0].oldmrnolabel);
    if (label == "" || label == null) {
      return "Old No"
    }
    else {
      return label;
    }
  }
  checkpatient() {
    // console.log("patient checked" + this.opdvisitService.patientdetails);
    if ((this.opdvisitService.patientdetails = {})) {
      console.log("patient checked found null ");
      return true;
    } else {
      return false;
    }
  }

  enablevipdd(event) {
    if (event.checked == true) {
      this.vipselected = true;
    } else {
      this.vipselected = false;
      this.opdvisitService.patientdetails.fkViprefId = 0;
    }
  }
  enabledisabledd(event) {
    if (event.checked == true) {
      this.disableselected = true;
    } else {
      this.disableselected = false;
      this.opdvisitService.patientdetails.fkDisablityId = 0;
    }
  }

  deletePatient() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: "500px"

      // data: { name: "xyz", animal: "Abc" }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
      console.log("The dialog was closed");
      //  this.animal = result;
    });
  }

  setfocus(sectionno: string) {
    console.log("set focus clicked" + sectionno);
    if (sectionno == "section1") {
      this.defaultautoRef.nativeElement.focus();
    } else {
      this.autofaxRef.nativeElement.focus();
    }
  }

  clear_and_set_default() {
    this.clearfields();
    this.validateobject();
    this.get_patients_fields_config();
  }

  clearfields() {
    this.childevent = true;
    this.opdvisitService.agehide = false;
    this.addresschecked = false;
    //console.log("clear clicked");
    this.controlfocusout = false;
    this.opdvisitService.patientdetails = {};
    this.opdvisitService.reffertypeid = 0;
    this.opdvisitService.set_date_and_time();
    this.opdvisitService.url = "";
    this.familyUHID = null;
    this.TempId = null;
    //this.opdvisitService.patientdetails.initial = 0;

    this.opdvisitService.patientdetails.careofType = null;
    this.opdvisitService.ShowGroupName = null;
    this.ShowPartyName = null;
    this.ShowNationalityName = null;
    this.opdvisitService.patientdetails.fK_DoctorId = null;
    this.opdvisitService.patientdetails.otherLanguages = null;
    this.opdvisitService.ShowOccupationName = null;
    this.opdvisitService.patientdetails.referredBy = null;
    this.opdvisitService.patientdetails.fkPcityId = null;
    this.opdvisitService.patientdetails.fkLcityId = null;
    this.opdvisitService.patientdetails.fkPareaId = null;
    this.opdvisitService.patientdetails.fkLareaId = 0;
    this.opdvisitService.stateid = 0;
    this.opdvisitService.localstateid = 0;
    this.opdvisitService.districtid = 0;
    this.opdvisitService.localdistrictid = 0;
    this.opdvisitService.countryid = 0;
    this.opdvisitService.localcountryid = 0;
    this.opdvisitService.patientdetails.fkMaritalId = 0;
    this.opdvisitService.patientdetails.fkBloodGroupId = 0;
    this.opdvisitService.patientdetails.fkDisablityId = 0;
    this.opdvisitService.patientdetails.fkGroupId = 0;
    this.opdvisitService.patientdetails.fkLanguageId = 0;
    this.opdvisitService.patientdetails.fkNationalityId = 0;
    this.opdvisitService.nationalityname = null;
    this.opdvisitService.partymaster_name = null;
    this.opdvisitService.patientdetails.fkOccupationId = 0;
    this.opdvisitService.patientdetails.fkReferredbyId = 0;
    this.opdvisitService.patientdetails.fkReligionId = 0;
    this.opdvisitService.patientdetails.fkSourceId = 0;
    this.opdvisitService.patientdetails.fkViprefId = 0;
    this.opdvisitService.patientdetails.fkPartyId = 0;
    this.opdvisitService.patientdetails.initial = null;
    this.opdvisitService.states = [];
    this.opdvisitService.states2 = [];
    this.opdvisitService.districts = [];
    this.opdvisitService.districts2 = [];
    this.opdvisitService.cities = [];
    this.opdvisitService.cities2 = [];
    this.opdvisitService.areas = [];
    this.opdvisitService.areas2 = [];

    // this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0]?.fK_CityId, 1);
    // if (this.patient_mendatory_fields[0]?.fK_LCityId != null) {
    //   this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0]?.fK_LCityId, 2);
    // }

  }

  updateage() {

    this.opdvisitService.updateage_allplaces(
      this.opdvisitService.patientdetails.pkRegId,
      this.opdvisitService.patientdetails.dob
    );
  }

  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  // Only Numbers with Decimals
  keyPressNumbersDecimal(event) {

    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
      return true;
    } else {

      return false;
    }

  }

  getsummary_url(patientid: number) {

    if (this.opdvisitService.patientdetails.pkRegId) {
      let checkreporttype = this.authService.webreportConfig.filter(item => item.printOption == 'Medical Record' && item.printType == 'NetramReport');
      if (checkreporttype.length > 0) {
        this.dashboardService.getsummary_url().pipe(takeUntil(this.destroytableList$)).subscribe(
          data => this.succesurl(data, patientid), err => this.failedurl(err)
        )
      } else {
        this.ipdService.printTimelineBill(patientid);
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  succesurl(data, patientid) {

    const urldate = data.filter(item => item.propertyName == 'WebURL');
    const url = urldate[0].propertyValue;

    var newWindow = window.open(url + 'PatientEMRSummary.aspx?RegID=' + patientid + '&BillCompanyName=' + this.authService.Loggeduser.billingcompanyname + '&VisitOrderType=DESC' + '&BranchId=' + this.authService.Loggeduser.branchid);

  }

  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  // openDialog(): void {
  //   const dialogRef = this.dialog.open(AgeDialogComponent, {
  //     width: '500px',

  //     data: { name: "xyz", animal: "Abc" }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     this.animal = result;
  //   });
  // }

  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      panelClass: "site-loader",
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
      console.log("The dialog was closed");
      //pid = result;
    });
  }


  //country code dialogbox 
  open_State_Dialog(): void {
    const dialogRef = this.dialog.open(StateMasterComponent, {
      width: "800px",
      height: "350px",
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
    });
  }

  //country code dialogbox 
  open_District_Dialog(): void {
    const dialogRef = this.dialog.open(DistrictMasterComponent, {
      width: "800px",
      height: "350px",
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
    });
  }
  //country code dialogbox 
  open_City_Dialog(): void {
    const dialogRef = this.dialog.open(CityMasterComponent, {
      width: "900px",
      height: "350px",
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
    });
  }
  //country code dialogbox 
  open_Area_Dialog(): void {
    const dialogRef = this.dialog.open(AreaMasterComponent, {
      width: "800px",
      height: "350px",
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
    });
  }
  //country code dialogbox 
  open_Country_Dialog(): void {
    const dialogRef = this.dialog.open(CountryMasterComponent, {
      width: "800px",
      height: "350px",
      data: {
        id: 1,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
    });
  }
  opendocdialog(): void {

    if (this.opdvisitService.patientdetails.pkRegId) {
      let patinfo = this.opdvisitService.patInfoDetails;
      const dialogRef = this.dialog.open(PatientdocsComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "80%",
        width: "50%",
        data: {
          patID: patinfo.pkRegId,
          patientName: patinfo.initial + ' ' + patinfo.firstName + ' ' + patinfo.lastName,
        }
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
        console.log("The dialog was closed");
        this.animal = result;
      });
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK")
    }
  }

  openwebcam_dialog() {
    if (this.opdvisitService.patientdetails.pkRegId) {
      const dialogRef = this.dialog.open(Webcam_photoComponent, {
        // maxWidth: "100vw !important",
        // height: "100%",
        width: "500px"
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
        this.opdvisitService.get_old_photo();
        this.animal = result;
      });
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK")
    }
  }

  opensearchDialog(type): void {
    if (this.screenPermissionobj?.searchPermission === true) {
      // this.open_loader_Dialog();
      // this.dashboardService.showspinner = true;
      // this.opdvisitService.get_top_200_patients().subscribe(
      //   data => this.success_top_200_patients(data),
      //   err => this.failed_top_200_patients(err)
      // );
      const dialogRef = this.dialog.open(SearchDialogComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "100vw !important",
        height: "80%",
        width: "90%",
        data: [{ TempShow: true, Type: type }]
      });

      dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {

        this.animal = result;
        if (type == 1 || type == 3) {
          if (result > 0) {
            this.controlfocusout = true;
            this.defaultautoRef.nativeElement.focus();
            console.log("The dialog was closed");
            if (this.opdvisitService.patientdetails.isvip == true) {
              this.vipselected = true;
            }

          } else {
            this.controlfocusout = false;
          }
        } else {
          if (result > 0 || result == undefined) {
            this.familyUHID = this.opdvisitService.patientdetails.pkRegId;
            this.getpatientdetailsforFamily(this.familyUHID);
          }
        }



      });
    }

    else {
      this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
    }

  }

  // success_top_200_patients(data) {
  //   this.dialog.closeAll();
  //   // this.dashboardService.showspinner = false;
  //   this.opdvisitService.patients = data;
  //   console.log("patients successfully loaded");

  //   // call dialogue once data get loaded inside success
  //   const dialogRef = this.dialog.open(SearchDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.animal = result;
  //     if(result >0){
  //       this.controlfocusout=true;
  //       this.defaultautoRef.nativeElement.focus();
  //       console.log("The dialog was closed");
  //       if(this.opdvisitService.patientdetails.isvip ==true){
  //         this.vipselected = true;
  //       }
  //     }else{
  //       this.controlfocusout=false;
  //     }


  //   });
  // }

  onFocusGetPatient(event) {

    if (this.controlfocusout != true) {
      let inputVal = event.target.value
      if (inputVal != '') {
        this.childevent = false;
        this.opdvisitService.getpatientdetails(inputVal, 0);
      }

    }

  }
  searchPateint(pid: any, type: any) {
    this.childevent = false;
    document.getElementById('abhaModal').style.display = 'none';
    this.opdvisitService.getpatientdetails(pid, type);
  }
  failed_top_200_patients(err) {
    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;
  }

  // opencampDialog(): void {
  //   const dialogRef = this.dialog.open(CampDialogComponent, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
  //     console.log("The dialog was closed");
  //     this.animal = result;
  //   });
  // }
  // openGeneralDialog(): void {
  //   const dialogRef = this.dialog.open(GeneralDialoag, {
  //     panelClass: "full-width-dialog",
  //     maxWidth: "100vw !important",
  //     height: "80%",
  //     width: "90%"
  //   });

  //   dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
  //     console.log("The dialog was closed");
  //     this.animal = result;
  //   });
  // }

  // pharmababatest(){
  //  this.http.get<any>("pharmababa.broadspectrum.in/public/webservices/get_news").
  //       subscribe(data => this.success_pb(data), err => this.failed_pb(err));
  // }
  // success_pb(data){
  // console.log("pb news list" + data);
  // }
  // failed_pb(err){
  //   console.log("api failed");
  // }

  ngOnInit() {
    this.opdvisitService.callsepecificApi = 'ALL';
    this.opdvisitService.agehide = false;
    this.open_loader_Dialog();
    this.opdvisitService.enableBarSticker = false;

    this.selectedLanguage = this.langservice.setlang;
    this.paramsubscription = this.route.params.subscribe((params: Params) => {
      this.opdvisitService.flag = params["flag"];
    });



    this.screenPermissionobj = {};
    this.fill_tab1_dd();

    this.fill_otherinfo_tab_dd();

    this.get_patients_fields_config();
    this.clearfields();

    setTimeout(() => {
      this.defaultautoRef.nativeElement.focus();
    }, 0);
    this.opdvisitService.url = "";
    this.getscreenPermission();

    this.groupControll();
    this.occupationControll();
    this.partyControll();
    this.referedbyControll();
    this.getdoctorlist();
    this.clearintialform();

  }
  formattimechange(appttime: string) {
    if (appttime == null) {
    } else {
      var hr_min_sec = appttime.split(".", 2);
      var hr_min = hr_min_sec[0].split(":", 3);
      return hr_min[0] + ":" + hr_min[1];
    }
    this.dashboardService.moudletype
      .pipe(takeUntil(this.destroytableList$))
      .subscribe((quote) => {
        if (quote == 1) {
          this.getdoctorlist();
        }
      });
  }
  // get doctor list 
  getdoctorlist() {
    this.dashboardService.getall_doctors().pipe(takeUntil(this.destroytableList$)).
      subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));
  }
  failed_doctors(err) {

  }
  success_doctors(data) {
    if (this.authService.masterdata.isExternal === true) {

      this.opdvisitService.doctors = data?.filter(item => item.isExternal == false);

    }
    else {
      this.opdvisitService.doctors = data;

    }
  }
  insertIntialModel() {
    let checkavilable = this.opdvisitService.initials.filter(item => item.initialName.toLocaleLowerCase() == this.newintial?.toLocaleLowerCase());
    if (checkavilable.length == 0) {
      let data = {
        "InitialMaster": {
          "IsEdit": false, "IsDelete": false, "PK_InitialId": 0,
          "initialName": this.newintial,
          "sex": this.intialGender == 'O' ? '' : this.intialGender,
          "careof": this.intialtype,
          "isActive": true,
          "pkSynchId": null
        }
      }
      this.registerService.insertMaster(data).pipe(takeUntil(this.destroytableList$)).subscribe(x => {
        this.clearintialform();
        this.opdvisitService.getinitials();
        this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      });
    } else {
      this.dashboardService.openSnackBar("Initial Name Already Exist", "OK");
    }

  }
  getcountrycode(countryCode) {

    // if(countryCode == null){
    //   countryCode = '+91';
    // }
    this.opdvisitService.getCountryCode().pipe(takeUntil(this.destroytableList$)).subscribe((x: any) => {
      console.log(x);
      if (x.length > 0) {
        let letcode = x.filter(item => item.pkCountryId == countryCode);
        this.opdvisitService.patientdetails.m_CountryCode = letcode[0]?.countryCode;
      }
    });

  }
  getscreenPermission() {
    let UserId = this.authService.Loggeduser.userid;
    this.billingservice.getbillingScreenPermission(UserId).pipe(takeUntil(this.destroytableList$)).subscribe(data => {

      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.screenName === "PATIENTREGISTRATION") {
          this.screenPermissionobj = element;
        }

      }

    })
  }

  keyDownFunction(event) {
    // if (event.keyCode === 13) {
    //   if (this.opdvisitService.patientdetails.pkRegId == 0 ||
    //     this.opdvisitService.patientdetails.pkRegId == null) {
    //      this.check_user_validation();
    //     }
    // }
  }

  get_patients_fields_config() {

    this.opdvisitService.getPatientConfig().pipe(takeUntil(this.destroytableList$)).subscribe(
      data => this.success_config(data),
      err => this.error_config(err)
    );
  }

  set_default_values() {
    //console.log("sid " + this.patient_mendatory_fields[0].fL_SourceId);

    if (this.patient_mendatory_fields[0].fK_GroupNameId != null) {
      this.opdvisitService.patientdetails.fkGroupId = parseInt((this.patient_mendatory_fields[0].fK_GroupNameId));
      let GrpName = this.opdvisitService.GroupList.filter(item => item.pkPopupId == this.opdvisitService.patientdetails.fkGroupId);
      if (GrpName.length > 0) {
        this.opdvisitService.ShowGroupName = GrpName[0].popupDescription;
      } else {
        this.opdvisitService.ShowGroupName = null;
      }
    }

    if (this.patient_mendatory_fields[0].fK_ReligionId != null) {
      this.opdvisitService.patientdetails.fkReligionId = parseInt((this.patient_mendatory_fields[0].fK_ReligionId));
    }

    if (this.patient_mendatory_fields[0].fK_OccupationId != null) {
      this.opdvisitService.patientdetails.fkOccupationId = this.patient_mendatory_fields[0].fK_OccupationId;
      let occName = this.opdvisitService.GetOccupation.filter(item => item.pkPopupId == this.patient_mendatory_fields[0].fK_OccupationId);
      if (occName.length > 0) {
        this.opdvisitService.ShowOccupationName = occName[0].popupDescription;
      } else {
        this.opdvisitService.ShowOccupationName = null;
      }
    }
    if (this.patient_mendatory_fields[0].fK_LanguageId != null) {
      this.opdvisitService.patientdetails.fkLanguageId = this.patient_mendatory_fields[0].fK_LanguageId;
    }
    if (this.patient_mendatory_fields[0].fK_InitialId != null) {

      for (let initial of this.opdvisitService.initials) {
        if (initial.pK_InitialId == this.patient_mendatory_fields[0].fK_InitialId) {

          this.opdvisitService.patientdetails.initial = initial.initialName;

          this.fill_gender_and_careof(initial.initialName);
        }
      }

      // this.opdvisitService.patientdetails.initial = this.patient_mendatory_fields[0].fK_InitialId;


    }
    if (this.patient_mendatory_fields[0].fK_AreaId != null) {
      this.opdvisitService.patientdetails.fkPareaId = Number(this.patient_mendatory_fields[0].fK_AreaId);
    }
    if (this.patient_mendatory_fields[0].fK_LAreaId != null) {
      this.opdvisitService.patientdetails.fkLareaId = Number(this.patient_mendatory_fields[0].fK_LAreaId);
    }

    if (this.patient_mendatory_fields[0].fL_SourceId != null) {
      this.opdvisitService.patientdetails.fkSourceId = this.patient_mendatory_fields[0].fL_SourceId;
    }
    if (this.patient_mendatory_fields[0].fK_CityId != null) {
      this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0].fK_CityId, 1);
    }
    if (this.patient_mendatory_fields[0].fK_LCityId != null) {

      this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0].fK_LCityId, 2);
    }
  }
  success_config(data) {
    //  this.showreg_form = true; this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0].fK_CityId, 1);
    this.patient_mendatory_fields = data;

    if (this.patient_mendatory_fields.length == 0) {
      this.dashboardService.openSnackBar("Please Update The Configuration The Patient in Masters ", "OK");
    } else {
      this.getcountrycode(data[0]?.fK_CountryId);
      this.set_default_values();
      if (this.patient_mendatory_fields[0]?.mandatoryInitial != true) {
        this.checkgender = false;
      }
    }



    //this.clearfields();

    //console.log("testing" + this.patient_mendatory_fields[0].mandatoryMobile);
    //console.log ("config works");
    // console.log(data);
  }
  error_config(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  fill_tab1_dd() {
    this.opdvisitService.getcountries();
    this.opdvisitService.getinitials();
    this.opdvisitService.getpartymaster();
    // this.opdvisitService.getpersonmaster('REGISTRATION',0);
    this.opdvisitService.get_patient_docurl();
  }

  fill_gender_and_careof(initials: string) {

    this.opdvisitService.patientdetails.initial = initials;
    var selectedinitials;
    for (let initial of this.opdvisitService.initials) {

      if (initial.initialName == initials && initial.sex != " ") {
        selectedinitials = initial;
        this.checkgender = true;
      } else if (initial.initialName == initials && initial.sex == " ") {
        this.checkgender = false;
        selectedinitials = initial;
      }
    }

    // console.log("initials " + initials);
    // var selectedinitials = this.opdvisitService.initials.find(
    //   item => item.pkInitialId == initials
    // );
    this.opdvisitService.patientdetails.sex = selectedinitials.sex;
    this.opdvisitService.patientdetails.careofType = selectedinitials.careof;

  }

  fill_otherinfo_tab_dd() {
    this.opdvisitService.get_otherinformation_tab_dd('MARITALSTATUS');
    this.opdvisitService.get_otherinformation_tab_dd('DISABLITY');
    // this.opdvisitService.get_otherinformation_tab_dd('GROUP');
    this.opdvisitService.get_otherinformation_tab_dd('BLOODGROUP');
    this.opdvisitService.get_otherinformation_tab_dd('LANGUAGE');
    // this.opdvisitService.get_otherinformation_tab_dd('OCCUPATION');
    this.opdvisitService.get_otherinformation_tab_dd('RELIGION');
    this.opdvisitService.get_otherinformation_tab_dd('SOURCE');
    this.opdvisitService.get_otherinformation_tab_dd('VIPREF');
    this.opdvisitService.get_otherinformation_tab_dd('NATIONALITY');
    this.nationalControll();
  }

  reMovedata(event: any) {

    if (event == "") {
      this.clear_and_set_default();
    }

  }

  letterOnly(event) {
    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 46 || charCode == 32)

      return true;
    else
      return false;
  }

  letterOnlType(event) {

    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 46 || charCode == 32 || charCode == 47)

      return true;
    else
      return false;
  }
  refReasonPOpup() {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: 'OtherLanguage'
      }

    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroytableList$)).subscribe(result => {
      if (result != 0) {

        this.opdvisitService.patientdetails.otherLanguages = result;
      }
    });
  }
  getage(selecteddate: string) {


    const checkcdate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    if (currentdate >= checkcdate) {
      this.getDataDiff(new Date(selecteddate), new Date(currentdate));
    } else {
      this.opdvisitService.patientdetails.dob = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.opdvisitService.patientdetails.ageYear = 0;
      this.opdvisitService.patientdetails.ageMonth = 0;
      this.opdvisitService.patientdetails.ageDays = 0;
    }
  }


  getpatientdetailsforFamily(id) {

    this.opdvisitService.patientdetails.m_CountryCode = null;
    this.dashboardService.subscriptions = this.opdvisitService.getpatientdetailsforReciept(id).pipe(takeUntil(this.destroytableList$)).subscribe((data: any) => {
      this.opdvisitService.patientdetails = data;
      this.opdvisitService.patientdetails.fkMaritalId = 0;
      this.opdvisitService.enableBarSticker = true;
      if (data.fkReferredbyIdLatest > 0) {
        data.fkReferredbyId = data.fkReferredbyIdLatest;
      }
      if (data.m_CountryCode == null) {
        this.opdvisitService.patientdetails.m_CountryCode = '+91';
      }
      this.opdvisitService.ShowOccupationName = null;
      this.opdvisitService.ShowGroupName = null;
      this.opdvisitService.partymaster_name = null;
      this.opdvisitService.nationalityname = null;
      this.opdvisitService.patientdetails.isBpl = null;
      this.opdvisitService.patientdetails.fkViprefId = 0;
      this.opdvisitService.patientdetails.fkBloodGroupId = 0;
      this.opdvisitService.patientdetails.motherName = null;
      this.opdvisitService.registereddate = data.regDate;
      this.opdvisitService.registeredtime = data.regTime;
      this.opdvisitService.checkpatient = data.pkRegId;
      this.opdvisitService.reffertypeid = this.opdvisitService.patientdetails.fkReferredbyId;
      if (this.opdvisitService.apptdetail.fkRefById != undefined && this.opdvisitService.apptdetail.fkRefById != null) {
        this.opdvisitService.patientdetails.fkReferredbyId = this.opdvisitService.apptdetail.fkRefById;
      }
      if (this.opdvisitService.patientdetails.dob == null) {
        this.getdob(1);
        this.getdob(2);
        this.getdob(3);
      } else {
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(this.authService.localDate, "yyyy-MM-dd");
      }

      this.opdvisitService.patientdetails.localpinCode = data.localPinCode;
      this.opdvisitService.PatientisExpire = data.isExpired;
      this.opdvisitService.PatientpartyId = data.fkPartyId
      if (this.opdvisitService.patientdetails.fkPcityId != null) {
        this.opdvisitService.get_city_district_state_country(this.opdvisitService.patientdetails.fkPcityId, 1);
      }
      if (this.opdvisitService.patientdetails.fkLcityId != null) {
        this.opdvisitService.get_city_district_state_country(this.opdvisitService.patientdetails.fkLcityId, 2);
      }
      this.opdvisitService.patientdetails.ageDays = null;
      this.opdvisitService.patientdetails.ageMonth = null;
      this.opdvisitService.patientdetails.ageYear = null;
      this.opdvisitService.patientdetails.pkRegId = null;
      this.opdvisitService.patientdetails.firstName = null;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  getdob(type: any) {

    switch (type) {

      case 1: {
        var tdate = new Date();
        if (this.opdvisitService.patientdetails.ageYear == null || this.opdvisitService.patientdetails.ageYear == undefined) {
          this.opdvisitService.patientdetails.ageYear = 0;
        }
        this.opdvisitService.patientdetails.ageMonth = 0;
        this.opdvisitService.patientdetails.ageDays = 0;
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 2: {
        var tdate = new Date();
        if (this.opdvisitService.patientdetails.ageMonth > 11 || this.opdvisitService.patientdetails.ageMonth <= 0) {
          this.dashboardService.openSnackBar("Please enter months in between 0 to 12", "OK");
          this.opdvisitService.patientdetails.ageMonth = 0;
          return false;
        }
        if (this.opdvisitService.patientdetails.ageYear == undefined || this.opdvisitService.patientdetails.ageYear == null) {
          this.opdvisitService.patientdetails.ageYear = 0;
        }
        this.opdvisitService.patientdetails.ageDays = 0;
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 3: {
        var tdate = new Date();
        if (this.opdvisitService.patientdetails.ageDays > 31 || this.opdvisitService.patientdetails.ageDays <= 0) {
          this.dashboardService.openSnackBar("Please enter days in between 0 to 31", "OK");
          this.opdvisitService.patientdetails.ageDays = 0;
          return false;
        }
        if ((this.opdvisitService.patientdetails.ageMonth == undefined || this.opdvisitService.patientdetails.ageMonth == null) && (this.opdvisitService.patientdetails.ageYear == undefined || this.opdvisitService.patientdetails.ageYear == null)) {
          this.opdvisitService.patientdetails.ageMonth = 0;
          this.opdvisitService.patientdetails.ageYear = 0;
        }
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.patientdetails.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.patientdetails.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.patientdetails.ageYear);
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
      }
    }



    // console.log("new date " + this.opdvisitService.apptdetail.dob);

  }
  getDataDiff(start, end) {
    let years: number = 0,
      months: number = 0,
      days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (
      end.getMonth() < start.getMonth() ||
      (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())
    ) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.opdvisitService.patientdetails.ageYear = years;
    this.opdvisitService.patientdetails.ageMonth = months;
    this.opdvisitService.patientdetails.ageDays = days;

  }

  getToday(): string {
    // return new Date().toISOString().split("T")[0];
    const today = new Date()
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1)
    today.toDateString()
    yesterday.toDateString()
    // console.log(yesterday);

    return yesterday.toISOString().slice(0, 10);
  }

  validateinitial: boolean = false;
  ValidatefirstName: boolean = false;
  ValidatelastName: boolean = false;
  validatemobile: boolean = false;
  validateaddress: boolean = false;
  validatemandatoryDOB: boolean = false;
  validateDOBAge: boolean = false;
  validateemail: boolean = false;
  validatemaritalstatus: boolean = false;
  validateoldmrno: boolean = false;
  validatereferredby: boolean = false;
  validatepartyname: boolean = false;
  validateemergencymobno: boolean = false;
  validateoccupation: boolean = false;
  validatepincode: boolean = false;
  validatelanguage: boolean = false;
  validategender: boolean = false;
  validatecountryName: boolean = false;
  validatestateName: boolean = false;
  validateDistrictName: boolean = false;
  validateCityName: boolean = false;
  Validatevip: boolean = false;
  validateNationality: boolean = false;
  check_user_validation() {

    this.isFavorite = true;
    this.validate_initial();
    this.Validate_firstName();
    this.Validate_lastName();
    this.validate_mobile();
    this.validate_DOBAge();
    this.validate_address();
    this.validate_mandatoryDOB();
    this.validate_email();
    this.validate_marital_status();
    this.validate_oldmrno();
    this.validate_referredby();
    this.validate_partyname();
    this.validate_emergency_mob_no();
    this.validate_occupation();
    this.validate_pincode();
    this.validate_language();
    // this.validate_group();
    this.validate_adharnumber();
    this.validate_abhaid();
    this.validate_gender();
    this.validate_countryName();
    this.validate_stateName();
    this.validate_DistrictName();
    this.validate_CityName();
    this.Validate_vip();
    this.validate_Nationality();
    if (this.user_validated != "") {
      const newstring = this.user_validated.substring(0, this.user_validated.length - 2);
      this.dashboardService.
        openSnackBar_regform("Please Check all Mandatory Fields Marked with * " + " " + newstring, "OK");
      this.user_validated = "";
    }
    else {
      // this.opdvisitService.patientdetails.firstName = this.checkTitlecase(this.opdvisitService.patientdetails.firstName);
      // if (this.opdvisitService.patientdetails.lastName != null && this.opdvisitService.patientdetails.lastName != undefined && this.opdvisitService.patientdetails.lastName != "") {
      //   this.opdvisitService.patientdetails.lastName = this.checkTitlecase(this.opdvisitService.patientdetails.lastName);
      // }
      if (this.opdvisitService.patientdetails.careofName != null && this.opdvisitService.patientdetails.careofName != undefined && this.opdvisitService.patientdetails.careofName != "") {
        this.opdvisitService.patientdetails.careofName = this.checkTitlecase(this.opdvisitService.patientdetails.careofName);
      }
      if (this.opdvisitService.patientdetails.towhom != null && this.opdvisitService.patientdetails.towhom != undefined && this.opdvisitService.patientdetails.towhom != "") {
        this.opdvisitService.patientdetails.towhom = this.checkTitlecase(this.opdvisitService.patientdetails.towhom);
      }
      if (this.opdvisitService.patientdetails.motherName != null && this.opdvisitService.patientdetails.motherName != undefined && this.opdvisitService.patientdetails.motherName != "") {
        this.opdvisitService.patientdetails.motherName = this.checkTitlecase(this.opdvisitService.patientdetails.motherName);
      }
      this.validateobject();
      this.savedetails();

    }
  }
  checkTitlecase(value) {
    if (value != null && value != undefined && value != '') {
      return value = (value.length > 1) ? value[0].toUpperCase() + value.substr(1).toLowerCase() : value.toUpperCase();
    } else {
      return null;
    }
  }

  validateobject() {
    this.validateinitial = false;
    this.ValidatefirstName = false;
    this.ValidatelastName = false;
    this.validatemobile = false;
    this.validateDOBAge = false;
    this.validateaddress = false;
    this.validatemandatoryDOB = false;
    this.validateemail = false;
    this.validatemaritalstatus = false;
    this.validateoldmrno = false;
    this.validatereferredby = false;
    this.validatepartyname = false;
    this.validateemergencymobno = false;
    this.validateoccupation = false;
    this.validatepincode = false;
    this.validatelanguage = false;
    this.validategender = false;
    this.validatecountryName = false;
    this.validatestateName = false;
    this.validateDistrictName = false;
    this.validateCityName = false;
    this.Validatevip = false;
    this.validateNationality = false;
  }
  validate_countryName() {

    if (this.opdvisitService.countryid == null || this.opdvisitService.countryid == 0) {
      this.validatecountryName = true;
      this.user_validated = this.user_validated + " " + "Country Name, " + " \n";
    }
  }
  validate_stateName() {

    if (this.opdvisitService.stateid == null || this.opdvisitService.stateid == 0) {
      this.validatestateName = true;
      this.user_validated = this.user_validated + " " + "State Name, " + " \n";
    }
  }
  validate_DistrictName() {

    if (this.opdvisitService.districtid == null || this.opdvisitService.districtid == 0) {
      this.validateDistrictName = true;
      this.user_validated = this.user_validated + " " + "District Name, " + " \n";
    }
  }
  validate_CityName() {

    if (this.opdvisitService.patientdetails.fkPcityId == null || this.opdvisitService.patientdetails.fkPcityId == 0) {
      this.validateCityName = true;
      this.user_validated = this.user_validated + " " + "City Name, " + " \n";
    }
  }

  Validate_firstName() {
    if (this.patient_mendatory_fields[0].mandatoryFirstName == true) {
      if (this.opdvisitService.patientdetails.firstName == null || this.opdvisitService.patientdetails.firstName == "") {
        this.ValidatefirstName = true;
        this.user_validated = this.user_validated + " " + "First Name, " + " \n";
      }
    }
  }
  Validate_lastName() {
    if (this.patient_mendatory_fields[0].mandatoryLastName == true) {
      if (this.opdvisitService.patientdetails.lastName == null || this.opdvisitService.patientdetails.lastName == "") {
        this.ValidatelastName = true;
        this.user_validated = this.user_validated + " " + "Last Name, " + " \n";
      }
    }
  }
  validate_address() {
    if (this.patient_mendatory_fields[0].mandatoryAddress == true) {
      if (this.opdvisitService.patientdetails.paddress == null || this.opdvisitService.patientdetails.paddress == "") {
        this.validateaddress = true;
        this.user_validated = this.user_validated + " " + "Address, " + " \n";
      }
    }
  }
  Validate_vip() {
    if (this.opdvisitService.patientdetails.isvip == true) {
      if (this.opdvisitService.patientdetails.fkViprefId == null) {
        this.Validatevip = true;
        this.user_validated = this.user_validated + " " + "VIP Type, " + " \n";
      }
    }
  }
  validate_mobile() {

    if (this.patient_mendatory_fields[0].mandatoryMobile == true) {
      if (this.opdvisitService.patientdetails.mobileNo == null) {
        this.validatemobile = true;
        this.user_validated = this.user_validated + " " + "Mobile No., " + " \n";
      }
    }
  }

  validate_mandatoryDOB() {

    if (this.patient_mendatory_fields[0].mandatoryDOB == true) {
      if (this.opdvisitService.patientdetails.dob == null || this.opdvisitService.patientdetails.dob == "") {
        this.validatemandatoryDOB = true;
        this.user_validated = this.user_validated + " " + "DOB, " + " \n";
      }
    }
  }

  validate_DOBAge() {

    if (this.opdvisitService.patientdetails.ageYear == null || this.opdvisitService.patientdetails.ageYear == undefined) {
      this.validateDOBAge = true;
      this.user_validated = this.user_validated + " " + "Age, " + " \n";
    }

  }

  validate_email() {

    if (this.patient_mendatory_fields[0].mandatoryEmail == true) {
      if (this.opdvisitService.patientdetails.emailAddress == null || this.opdvisitService.patientdetails.emailAddress == "") {
        this.validateemail = true;
        this.user_validated = this.user_validated + " " + "EMAIL, " + " \n";
      }
    }
  }
  validate_marital_status() {
    if (this.patient_mendatory_fields[0].mandatoryMaritalStatus == true) {
      if (this.opdvisitService.patientdetails.fkMaritalId == 0) {
        // this.user_validated += 1;
        this.validatemaritalstatus = true;
        this.user_validated = this.user_validated + " " + "MARITAL STATUS, " + " \n";
      }
    }
  }

  validate_oldmrno() {
    if (this.patient_mendatory_fields[0].mandatoryOldmrno == true) {
      if (this.opdvisitService.patientdetails.oldMrno == null || (this.opdvisitService.patientdetails.oldMrno).toString() == "") {
        // this.user_validated += 1;
        this.validateoldmrno = true;
        this.user_validated = this.user_validated + " " + "Old UHID, " + " \n";
      }
    }
  }

  validate_referredby() {

    if (this.patient_mendatory_fields[0].mandatoryReferredby == true) {
      if (this.opdvisitService.patientdetails.referredBy == "" || this.opdvisitService.patientdetails.fkReferredbyId == 0 || this.opdvisitService.patientdetails.referredBy == null) {
        // this.user_validated += 1;
        this.validatereferredby = true;
        this.user_validated = this.user_validated + " " + "Referred By, " + " \n";
      }
    }
  }
  validate_partyname() {
    if (this.patient_mendatory_fields[0].mandatoryPartyName == true) {
      if (this.opdvisitService.partymaster_name == "" || this.opdvisitService.patientdetails.fkPartyId == 0) {
        //this.user_validated += 1;
        this.validatepartyname = true;
        this.user_validated = this.user_validated + " " + "PARTY NAME, " + " \n";
      }
    }
  }
  validate_initial() {
    if (this.patient_mendatory_fields[0].mandatoryInitial == true) {
      if (this.opdvisitService.patientdetails.initial == null || this.opdvisitService.patientdetails.initial == "") {
        //this.user_validated += 1;
        this.validateinitial = true;
        this.user_validated = this.user_validated + " " + "Initial, " + " \n";
      }
      //this.validate_gender();
    }
  }

  validate_occupation() {
    if (this.patient_mendatory_fields[0].mandatoryOcupation == true) {
      if (this.opdvisitService.ShowOccupationName == "" || this.opdvisitService.patientdetails.fkOccupationId == 0) {
        this.validateoccupation = true;
        this.user_validated = this.user_validated + " " + "OCCUPATION, " + " \n";
        // this.user_validated += 1;
      }
    }
  }

  validate_emergency_mob_no() {

    if (this.patient_mendatory_fields[0].mandatoryEmergencyMob == true) {
      if (this.digits_count(this.opdvisitService.patientdetails.emmergencyNo) > 9) {
        if (this.opdvisitService.patientdetails.emmergencyNo == null || (this.opdvisitService.patientdetails.emmergencyNo).toString() == "") {
          //this.user_validated += 1;
          this.validateemergencymobno = true;
          this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO, " + " \n";
        }
      } else {
        this.validateemergencymobno = true;
        this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO SHOULD BE 10 DIGIT, " + " \n";
        //this.dashboardService.openSnackBar("Mobile Number should be in 10 digit", "OK");
      }

    } else {
      if (this.opdvisitService.patientdetails.emmergencyNo != null && this.opdvisitService.patientdetails.emmergencyNo.toString() != "" && this.opdvisitService.patientdetails.emmergencyNo.toString() != " ") {
        if (this.digits_count(this.opdvisitService.patientdetails.emmergencyNo) > 9) {

        } else {
          this.user_validated = this.user_validated + " " + "EMERGENCY MOB NO SHOULD BE 10 DIGIT, " + " \n";
        }
      }
    }
  }

  validate_pincode() {
    if (this.patient_mendatory_fields[0].mandatoryPincode == true) {
      if (this.opdvisitService.patientdetails.pinCode == undefined && this.opdvisitService.patientdetails.pinCode == null) {
        // this.user_validated += 1;
        this.validatepincode = true;
        this.user_validated = this.user_validated + " " + "Pincode, " + " \n";
      } else if (this.digits_count(this.opdvisitService.patientdetails.pinCode) < 4) {
        this.user_validated = this.user_validated + " " + "Please enter miminum four digit pincode, " + " \n";
      }
    }
  }

  validate_gender() {


    if (this.opdvisitService.patientdetails.sex == null || this.opdvisitService.patientdetails.sex == " ") {
      // this.user_validated += 1;
      this.validategender = true;
      this.user_validated = this.user_validated + " " + "Gender, " + " \n";
    }

  }

  validate_language() {
    if (this.patient_mendatory_fields[0].mandatoryLanguage == true) {
      if (this.opdvisitService.patientdetails.fkLanguageId == 0) {
        this.validatelanguage = true;
        this.user_validated = this.user_validated + " " + "LANGUAGE, " + " \n";
      }
    }
  }

  validate_group() {

    if (this.patient_mendatory_fields[0].mandatoryGroupName == true) {
      if (this.opdvisitService.patientdetails.fkGroupId == 0) {
        this.user_validated = this.user_validated + " " + "GROUPNAME, " + " \n";
      }
    }
  }

  validate_adharnumber() {
    if (this.opdvisitService.patientdetails.adharCardNo != null && this.opdvisitService.patientdetails.adharCardNo != "") {
      if (this.digits_count(this.opdvisitService.patientdetails.adharCardNo) != 12) {
        this.user_validated = this.user_validated + " " + "Please enter 12 digit Aadhar Number, " + " \n";
      }
    }
  }
  validate_abhaid() {
    if (this.opdvisitService.patientdetails.abhaID != null && this.opdvisitService.patientdetails.abhaID != "") {
      if (this.digits_count(this.opdvisitService.patientdetails.abhaID) != 14) {
        this.user_validated = this.user_validated + " " + "Please enter 14 digit ABHA ID Number, " + " \n";
      }
    }
  }
  validate_Nationality() {
    if (this.patient_mendatory_fields[0].mandatoryNationality == true) {
      if (this.opdvisitService.nationalityname == null || this.opdvisitService.nationalityname == 0) {
        this.validateNationality = true;
        this.user_validated = this.user_validated + " " + "Nationality, " + " \n";
      }
    }
  }
  savedetails() {
    // this.check_user_validation();
    if (this.opdvisitService.patientdetails.ageYear != null && this.opdvisitService.patientdetails.ageYear != undefined) {
      if (this.opdvisitService.patientdetails.ageYear <= 200) {
        if (this.opdvisitService.patientdetails.pkRegId == 0 ||
          this.opdvisitService.patientdetails.pkRegId == null) {
          if (this.screenPermissionobj?.addPermission === true) {
            this.checkphone_no();
          }
          else {
            this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
          }


        }
        else if (this.opdvisitService.patientdetails.pkRegId > 0) {

          console.log("progress");
          if (this.screenPermissionobj?.modifyPermission === true) {
            if (this.digits_count(this.opdvisitService.patientdetails.phoneRes) > 9 || this.opdvisitService.patientdetails.phoneRes == null || this.opdvisitService.patientdetails.phoneRes == undefined || (this.opdvisitService.patientdetails.phoneRes).toString() == "") {
              if (this.digits_count(this.opdvisitService.patientdetails.mobileNo) > 9 || this.patient_mendatory_fields[0].mandatoryMobile != true) {
                this.opdvisitService.updatepatient();
              } else {
                this.dashboardService.openSnackBar("MOBILE NO SHOULD BE 10 DIGIT", "OK");

              }
            } else {
              this.dashboardService.openSnackBar("PHONE NO SHOULD BE 10 DIGIT", "OK");
            }


          }
          else {
            this.dashboardService.openSnackBar("you don't have permission to access this resource", "OK");
          }

        }
      } else {
        this.dashboardService.openSnackBar("Age Can't More than 200 Year", "OK");
      }

    }
    else {
      this.dashboardService.openSnackBar("Please check all mandatory fields marked with *Age", "OK");
    }
  }


  checkphone_no() {
    if (this.digits_count(this.opdvisitService.patientdetails.phoneRes) > 9 || this.opdvisitService.patientdetails.phoneRes == null || this.opdvisitService.patientdetails.phoneRes == undefined || (this.opdvisitService.patientdetails.phoneRes).toString() == "") {
      if (this.digits_count(this.opdvisitService.patientdetails.mobileNo) > 9 || this.patient_mendatory_fields[0].mandatoryMobile == false) {
        this.dashboardService.subscriptions = this.dashboardService.getMobilenUmber(this.opdvisitService.patientdetails.mobileNo)
          .subscribe(
            data => this.successphoneno(data),
            err => this.failphoneno(err)
          );
        this.open_loader_Dialog();
      }
      else {
        this.dashboardService.openSnackBar(" Number Should Be 10 digit", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("PHONE NO SHOULD BE 10 DIGIT", "OK");
    }


  }

  //number count 
  digits_count(n) {
    var count = 0;
    if (n >= 1) ++count;

    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }

    return count;
  }

  successphoneno(data) {

    this.phonedata = data;
    if (data.length > 0) {
      this.dialog.closeAll();
      this.openconfirmation_box();
    } else {
      this.controlfocusout = false;
      // this.opdvisitService.patientdetails.EntryFrom ="webNetram";
      this.opdvisitService.savepatientdetails();
    }
  }

  failphoneno(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  openconfirmation_box(): void {
    const dialogRef = this.dialog.open(Phoneno_confirmation_dialogComponent, {
      width: "500px",
      data: {
        PhoneData: this.phonedata,
        //userid: this.authService.Loggeduser.userid

      }

    }
    );


    dialogRef.afterClosed().subscribe(result => {
      console.log("The dialog was closed");

    });

  }
  setage(year: number, months: number, days: number, gender) {
    if (year > 0) {
      return year + "(Y)/" + gender;
    }
    else if (months > 0) {
      return months + "(M)/" + gender;
    }
    else if (days > 0) {
      return days + "(D)/" + gender;
    }
    else {
      return "";
    }
  }
  getfinyearstring(finyearid: number) {

    return this.authService.FinYears.find(fy => fy.pkFinYearId == finyearid).displayFinYear;

  }
  transfornDate(getdate: any) {
    return this.datePipe.transform(getdate, "MM-dd-yyyy")
  }

  print(): void {

    if (this.opdvisitService.patientregistrikerprint == true || this.opdvisitService.enableBarSticker == true) {
      if (this.opdvisitService.patientdetails.pkRegId) {
        let printContents, popupWin;
        printContents = document.getElementById('content').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
       
    <body onload="window.print()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
      }
      else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }
    }
  }

  setage1(year: number, months: number, days: number, gender) {

    var combine;
    if (year > 0 && months == 0 && days == 0) {
      return year + " Yrs |" + gender;
    }
    else if (months > 0 && year == 0 && days == 0) {
      return months + " Month |" + gender;
    }
    else if (days > 0 && months == 0 && year == 0) {
      return days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days == 0) {
      return year + "Yrs " + months + " Month |" + gender;
    } else if (months > 0 && days > 0 && year == 0) {
      return months + " Month " + days + " Days |" + gender;
    } else if (year > 0 && days > 0 && months == 0) {
      return year + " Yrs " + days + " Days |" + gender;
    } else if (year > 0 && months > 0 && days > 0) {
      return year + " Yrs " + months + " Month " + days + " Days |" + gender;
    }
    else {
      return "";
    }
  }
  getstates(countryid: number, option: number) {

    if (option == 1) {
      this.opdvisitService.stateid = 0;
      this.opdvisitService.districtid = 0;
      this.opdvisitService.patientdetails.fkPcityId = 0
      this.opdvisitService.patientdetails.fkPareaId = 0;
    } else {
      this.opdvisitService.localstateid = 0;
      this.opdvisitService.localdistrictid = 0;
      this.opdvisitService.patientdetails.fkLcityId = 0;
      this.opdvisitService.patientdetails.fkLareaId = 0;
    }
    this.opdvisitService.getstates(countryid, option);
  }

  getarea(cityid: number, option: number) {

    console.log("cityid " + cityid);
    this.opdvisitService.getareas(cityid, option);
  }
  getdistricts(stateid: number, option: number) {

    if (option == 1) {

      this.opdvisitService.districtid = 0;
      this.opdvisitService.patientdetails.fkPcityId = 0
      this.opdvisitService.patientdetails.fkPareaId = 0;
    } else {
      this.opdvisitService.localdistrictid = 0;
      this.opdvisitService.patientdetails.fkLcityId = 0;
      this.opdvisitService.patientdetails.fkLareaId = 0;
    }
    this.opdvisitService.getdistricts(stateid, option);

  }
  getcities(disid: number, option: number) {

    if (option == 1) {
      this.opdvisitService.patientdetails.fkPcityId = 0
      this.opdvisitService.patientdetails.fkPareaId = 0;
    } else {
      this.opdvisitService.patientdetails.fkLcityId = 0;
      this.opdvisitService.patientdetails.fkLareaId = 0;
    }
    this.opdvisitService.getcities(disid, option);
  }

  savepatient(regform: NgForm) { }

  success_states_sameas(data) {
    this.dialog.closeAll();
    //this.dashboardService.showspinner = false;
    this.opdvisitService.states2 = data;

    this.opdvisitService.localstateid = this.opdvisitService.stateid;

    //fill districts
    this.opdvisitService
      .getdistricts_sameas(this.opdvisitService.localstateid).pipe(takeUntil(this.destroytableList$))
      .subscribe(
        data => this.success_districts_sameas(data),
        err => this.failed_districts_sameas(err)
      );
  }
  failed_states_sameas(err) {
    this.dialog.closeAll();
    //this.dashboardService.showspinner = false;
  }
  success_districts_sameas(data) {
    this.opdvisitService.districts2 = data;
    this.opdvisitService.localdistrictid = this.opdvisitService.districtid;
    //fill cities
    this.opdvisitService
      .getcities_sameas(this.opdvisitService.localdistrictid).pipe(takeUntil(this.destroytableList$))
      .subscribe(
        data => this.success_cities_sameas(data),
        err => this.failed_cities_sameas(err)
      );
  }
  failed_districts_sameas(err) { }
  success_cities_sameas(data) {
    this.opdvisitService.cities2 = data;
    this.opdvisitService.patientdetails.fkLcityId = this.opdvisitService.patientdetails.fkPcityId;

    //fill areas
    this.opdvisitService
      .getareas_sameas(this.opdvisitService.patientdetails.fkLcityId).pipe(takeUntil(this.destroytableList$))
      .subscribe(
        data => this.success_areas_sameas(data),
        err => this.failed_areas_sameas(err)
      );
  }

  success_areas_sameas(data) {
    this.opdvisitService.areas2 = data;
    this.opdvisitService.patientdetails.fkLareaId = this.opdvisitService.patientdetails.fkPareaId;

  }
  failed_areas_sameas(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  failed_cities_sameas(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  filllocaladd(event) {
    this.addresschecked = true;

    console.log(event.checked);
    if (event.checked == true) {
      this.open_loader_Dialog();

      //this.dashboardService.showspinner = true;
      this.opdvisitService.patientdetails.localAddress = this.opdvisitService.patientdetails.paddress;
      //event.lcountry.value = "93";
      this.opdvisitService.localcountryid = this.opdvisitService.countryid;
      this.opdvisitService.patientdetails.localpinCode = this.opdvisitService.patientdetails.pinCode;

      //fill states
      this.dashboardService.subscriptions = this.opdvisitService
        .getstates_sameas(this.opdvisitService.localcountryid).pipe(takeUntil(this.destroytableList$))
        .subscribe(
          data => this.success_states_sameas(data),
          err => this.failed_states_sameas(err)
        );
    } else {
      this.opdvisitService.patientdetails.localAddress = "";
      this.opdvisitService.localcountryid = 0;
      this.opdvisitService.localstateid = 0;
      this.opdvisitService.localdistrictid = 0;
      this.opdvisitService.patientdetails.fkLcityId = 0;
      this.opdvisitService.patientdetails.fkLareaId = 0;
      this.opdvisitService.patientdetails.localpinCode = "";
    }
  }



  InitialMaster() {
    document.getElementById("InitialMasterModal").style.display = "block";
  }
  cancelInitialMaster() {
    document.getElementById("InitialMasterModal").style.display = "none";
  }


  alertModal() {
    document.getElementById("alertModal").style.display = "block";
  }
  cancelAlertModal() {
    document.getElementById("alertModal").style.display = "none";
  }
  CheckinputDoctor(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.referedbyControll();
      this.opdvisitService.patientdetails.fkReferredbyId = null;
      // this.ShowDoctorName = null;
    }
  }

  printTimeline() {
    let payload = {
      "WebReportPrintMaster": {
        "module": "Registration",
        "printOption": "PatientSticker",
        "printType": "WebNetramReport",
        "PRINTTYPESOCKET": this.opdvisitService.PrintTypeSocket,
        "PATIENTNAME": this.opdvisitService.patientdetails.initial + " " + this.opdvisitService.patientdetails.firstName +
          " " +
          this.opdvisitService.patientdetails.lastName,
        "MRDNO": this.opdvisitService.patientdetails.pkRegId,
        "MobileNo": this.opdvisitService.patientdetails.mobileNo,
        "PatientAddress": this.opdvisitService.patientdetails.paddress,
        "PRINTDATE": this.datePipe.transform(this.authService.localDate, "dd-MM-yyyy"),
        "PrintTime": this.convertTime12Hour(this.authService.localDate),
        "PatientAge": this.opdvisitService.patientdetails.ageYear,
        "PatientGender": this.opdvisitService.patientdetails.sex,
        "PatientAgeAndGender": this.setage1(
          this.opdvisitService.patientdetails.ageYear,
          this.opdvisitService.patientdetails.ageMonth,
          this.opdvisitService.patientdetails.ageDays,
          this.opdvisitService.patientdetails.sex
        ),
        "REGDATE": this.datePipe.transform(this.opdvisitService.patientdetails.regDate, "dd-MM-yyyy"),
        "CAREOFNAME": this.opdvisitService.patientdetails.careofName
      }

    }

    this.ipdService.GetWebReportPrint(payload).pipe(takeUntil(this.destroytableList$)).subscribe((x: any) => {
      if (x.length > 0) {
        if (this.opdvisitService.PrintTypeSocket > 0) {
          let printContents, popupWin;

          printContents = x[0].printTemplate;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

          popupWin.document.open();
          popupWin.document.write(`
        <html>
         
      <body >${printContents}
      </body>
        </html>`
          );

          popupWin.document.close();
        } else {
          let printContents, popupWin;

          printContents = x[0].printTemplate;
          popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

          popupWin.document.open();
          popupWin.document.write(`
     <html>
      
   <body onload="window.print()">${printContents}
   </body>
     </html>`
          );

          popupWin.document.close();
        }
      } else {
        this.dashboardService.openSnackBar("Report Template Not Set", "OK");
      }
    }, err => {
      this.dashboardService.openSnackBar("Api Failed", "OK");
    })
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour > 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }

  getPateintTempDetails(id) {

    this.opdvisitService.getPateintTempDetails(id, 0, 0, 0, 0).pipe(takeUntil(this.destroytableList$)).subscribe((data: any) => {
      if (data != '' && data != null) {
        this.opdvisitService.patientdetails = data[0];
        this.opdvisitService.patientdetails.TempReg_Pk_TranID = id;
        this.opdvisitService.patientdetails.fkPcityId = data[0].fK_PCityId;
        this.opdvisitService.patientdetails.pkRegId = data[0].fK_RegID;
        this.opdvisitService.patientdetails.paddress = data[0].patientAddress;
        this.opdvisitService.patientdetails.dob = this.datePipe.transform(data[0].dob, "yyyy-MM-dd");
        if (this.opdvisitService.patientdetails.m_CountryCode == null) {
          this.opdvisitService.patientdetails.m_CountryCode = '+91';
        }
        this.opdvisitService.get_city_district_state_country(this.opdvisitService.patientdetails.fkPcityId, 1);

      } else {
        this.dashboardService.openSnackBar("Please Select Temporery Id", "ok")
        this.clear_and_set_default();
      }

    })
  }
  ngOnDestroy(): void {
    this.childevent = null;
    this.opdvisitService.patientdetails = null;
    this.user_validated = null;
    this.screenPermissionobj = null;
    this.patient_mendatory_fields = null;
    this.selectedLanguage = null;
    this.checkgender = null;
    this.newintial = null;
    this.intialGender = null;
    this.familyUHID = null;
    this.TempId = null;
    this.intialtype = null;
    this.ShowPartyName = null;
    this.ShowNationalityName = null;
    this.animal = null;
    this.phonedata = null;
    this.filterTerm = null;
    this.filterTerm1 = null;
    this.filterTerm2 = null;
    this.filterTerm3 = null;
    this.filterTerm4 = null;
    this.filterTerm5 = null;
    this.filteredNationalityArray = null;
    this.filteredReferedbyArray = null;
    this.opdvisitService.states2 = null;
    this.opdvisitService.districts2 = null;
    this.opdvisitService.cities2 = null;
    this.opdvisitService.areas2 = null;
    this.filteredPartyArray = null;
    this.opdvisitService.GetBloodgroup = null;
    this.opdvisitService.GetLaungauge = null;
    this.opdvisitService.GetReligion = null;
    this.filteredOcupationArray = null;
    this.opdvisitService.GetSource = null;
    // this.opdvisitService.doctors=null;
    this.opdvisitService.GetDisability = null;
    this.abhaidobject = null;
    this.abhaprofiledetail = null;
    this.abhaotp = null;
    this.abhaotp1 = null;
    this.abhaotp2 = null;
    this.abhaotp3 = null;
    this.abhaotp4 = null;
    this.abhaSlots = null;
    this.abhaSlots1 = null;
    this.storetype = null;
    this.messagetype = null;
    this.destroytableList$.next(true);
    this.destroytableList$.unsubscribe();
    this.paramsubscription.unsubscribe();

  }

  //ABHA ID Integration
  // encryptedAadhaar: any;
  // encryptAadhaar(publickey) {
  //   const adharno = '879696956951';
  //   try {
  //     this.encryptedAadhaar = this.rsaEncryptionService.encryptAadhaar(adharno, publickey);
  //     console.log(this.encryptedAadhaar);
  //   } catch (error) {
  //     console.error('Encryption error', error);
  //   }
  // }

  items: string[] = ['Namesurname_239904', 'Namesurname_24304', 'Namesurname_239904', 'Namesurname_04304'];
  abhaidobject: ABHAIDModel = {};

  // ViewChild references for each input slot
  @ViewChild('slot0') slot0: ElementRef | undefined;
  @ViewChild('slot1') slot1: ElementRef | undefined;
  @ViewChild('slot2') slot2: ElementRef | undefined;
  @ViewChild('slot30') slot30: ElementRef | undefined;
  @ViewChild('slot31') slot31: ElementRef | undefined;
  @ViewChild('slot32') slot32: ElementRef | undefined;
  @ViewChild('slot40') slot40: ElementRef | undefined;
  @ViewChild('slot41') slot41: ElementRef | undefined;
  @ViewChild('slot42') slot42: ElementRef | undefined;
  @ViewChild('slot43') slot43: ElementRef | undefined;
  @ViewChild('otp0') otp0: ElementRef | undefined;
  @ViewChild('otp1') otp1: ElementRef | undefined;
  @ViewChild('otp2') otp2: ElementRef | undefined;
  @ViewChild('otp3') otp3: ElementRef | undefined;
  @ViewChild('otp4') otp4: ElementRef | undefined;
  @ViewChild('otp5') otp5: ElementRef | undefined;
  @ViewChild('otp10') otp10: ElementRef | undefined;
  @ViewChild('otp11') otp11: ElementRef | undefined;
  @ViewChild('otp12') otp12: ElementRef | undefined;
  @ViewChild('otp13') otp13: ElementRef | undefined;
  @ViewChild('otp14') otp14: ElementRef | undefined;
  @ViewChild('otp15') otp15: ElementRef | undefined;
  @ViewChild('otp20') otp20: ElementRef | undefined;
  @ViewChild('otp21') otp21: ElementRef | undefined;
  @ViewChild('otp22') otp22: ElementRef | undefined;
  @ViewChild('otp23') otp23: ElementRef | undefined;
  @ViewChild('otp24') otp24: ElementRef | undefined;
  @ViewChild('otp25') otp25: ElementRef | undefined;
  @ViewChild('otp30') otp30: ElementRef | undefined;
  @ViewChild('otp31') otp31: ElementRef | undefined;
  @ViewChild('otp32') otp32: ElementRef | undefined;
  @ViewChild('otp33') otp33: ElementRef | undefined;
  @ViewChild('otp34') otp34: ElementRef | undefined;
  @ViewChild('otp35') otp35: ElementRef | undefined;
  @ViewChild('otp40') otp40: ElementRef | undefined;
  @ViewChild('otp41') otp41: ElementRef | undefined;
  @ViewChild('otp42') otp42: ElementRef | undefined;
  @ViewChild('otp43') otp43: ElementRef | undefined;
  @ViewChild('otp44') otp44: ElementRef | undefined;
  @ViewChild('otp45') otp45: ElementRef | undefined;
  @ViewChild(MatStepper) stepper!: MatStepper;
  abhaSlots: string[] = ['', '', ''];
  abhaSlots1: string[] = ['', '', ''];
  abhanumber: string[] = ['', '', '', ''];
  isInputError: boolean = false;
  abhaotp: string[] = ['', '', '', '', '', ''];
  abhaotp1: string[] = ['', '', '', '', '', ''];
  abhaotp2: string[] = ['', '', '', '', '', ''];
  abhaotp3: string[] = ['', '', '', '', '', ''];
  abhaotp4: string[] = ['', '', '', '', '', ''];
  @ViewChild("defaultmobile", { static: false }) private defaultmobileRef: ElementRef;
  @ViewChild("defaultadhar", { static: false }) private defaultadharRef: ElementRef;
  @ViewChild("defaultabhaid", { static: false }) private defaultabhaidRef: ElementRef;
  // Automatically move focus to the next input
  clearAutoSuggestion(event: any) {
    event.target.setAttribute("autocomplete", "off");
    event.target.setAttribute("readonly", "true");
    setTimeout(() => {
      event.target.removeAttribute("readonly");
    }, 100);
  }
  onInputabhano(index: number, event): void {

    if (this.abhanumber[index].length === 2 && index == 0) {
      if (index < 3) {
        const nextSlot = this[`slot4${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
      this.abhaprofiledetail.ABHANumber = this.abhanumber.join('-');
    } else if (this.abhanumber[index].length === 4 && index > 0) {
      if (index < 3) {
        const nextSlot = this[`slot4${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
      this.abhaprofiledetail.ABHANumber = this.abhanumber.join('-');
    } else if (this.abhanumber[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`slot4${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
      this.abhaprofiledetail.ABHANumber = this.abhanumber.join('-');
    }

    if (String(this.abhaprofiledetail.ABHANumber).length > 17) {
      this.abhaprofiledetail.ABHANumber = this.abhaprofiledetail.ABHANumber.slice(0, -1);
    }

    this.validateInput('slot4');  // Validate the input after each entry
    this.clearAutoSuggestion(event);
  }
  onInput(index: number, event): void {

    if (this.abhaSlots[index].length === 4) {
      if (index < 2) {
        const nextSlot = this[`slot${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    }
    else if (this.abhaSlots[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`slot${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.adharno = this.abhaSlots.join('');

    this.validateInput('slot');  // Validate the input after each entry
    this.clearAutoSuggestion(event);
  }
  onInputfatch(index: number, event): void {

    if (this.abhaSlots1[index].length === 4) {
      if (index < 2) {
        const nextSlot = this[`slot3${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    } else if (this.abhaSlots1[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`slot3${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.adharno = this.abhaSlots1.join('');
    this.clearAutoSuggestion(event);
    this.validateInput('slot3');

  }
  // Validate input: Ensure all slots are filled
  validateInput(type): void {
    // If any slot is not filled, set the error flag
    this.isInputError = this.abhaSlots.some(type => type.length < 4);
  }

  onInputotp(index: number, event): void {

    if (this.abhaotp[index].length === 1) {
      if (index < 5) {
        const nextSlot = this[`otp${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    } else if (this.abhaotp[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`otp${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.verifyotpno = this.abhaotp.join('');
    // this.validateInputopt();  // Validate the input after each entry
    this.clearAutoSuggestion(event);
  }
  onInputotp1(index: number, event): void {
    if (this.abhaotp1[index].length === 1) {
      if (index < 5) {
        const nextSlot = this[`otp1${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    } else if (this.abhaotp1[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`otp1${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.verifyotpno = this.abhaotp1.join('');
    // this.validateInputopt();  // Validate the input after each entry
    this.clearAutoSuggestion(event);
  }
  onInputotp2(index: number, event): void {
   
    if (this.abhaotp2[index].length === 1) {
      if (index < 5) {
        const nextSlot = this[`otp2${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    }
    else if (this.abhaotp2[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`otp2${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.verifyotpno = this.abhaotp2.join('');
    // this.validateInputopt();  // Validate the input after each entry
    this.clearAutoSuggestion(event);
  }
  onInputotp3(index: number, event): void {

    if (this.abhaotp3[index].length === 1) {
      if (index < 5) {
        const nextSlot = this[`otp3${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    } else if (this.abhaotp3[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`otp3${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.verifyotpno = this.abhaotp3.join('');
    this.clearAutoSuggestion(event);
  }
  onInputotp4(index: number, event): void {

    if (this.abhaotp4[index].length === 1) {
      if (index < 5) {
        const nextSlot = this[`otp4${index + 1}`]?.nativeElement as HTMLInputElement;
        nextSlot?.focus();
      }
    } else if (this.abhaotp4[index].length === 0 && event?.inputType === "deleteContentBackward") {
      if (index > 0) {
        const prevSlot = this[`otp4${index - 1}`]?.nativeElement as HTMLInputElement;
        prevSlot?.focus();
      }
    }

    this.abhaidobject.verifyotpno = this.abhaotp4.join('');
    this.clearAutoSuggestion(event);
  }
  // Validate input: Ensure all slots are filled
  validateInputopt(): void {
    // If any slot is not filled, set the error flag
    this.isInputError = this.abhaotp.some(otp => otp.length < 1);
  }
  // Validate number input: Only allow numeric characters
  validateNumberInput(event: KeyboardEvent): void {
    const char = event.key;
    if (isNaN(Number(char)) && char !== 'Backspace' && char !== 'Tab' && char !== 'ArrowLeft' && char !== 'ArrowRight') {
      event.preventDefault();  // Prevent non-numeric input
    }
  }
  abhaModal() {
    this.abhaidobject = {};
    this.abhaprofiledetail = {};
    this.stepper.reset();
    document.getElementById('abhaModal').style.display = 'block';
  }
  closeAbhaModal() {
    document.getElementById('abhaModal').style.display = 'none';
  }
  inputType: any = 'password';
  toggleVisibility() {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }
  abhaDetailsModal() {

    document.getElementById('abhaDetailsModal').style.display = 'block';
    document.getElementById('abhaModal').style.display = 'none';
    this.abhaidobject = {};
    this.abhaidobject.isagree = false;
    this.abhaprofiledetail = {};
    this.abhaotp = ['', '', '', '', '', ''];
    this.abhaotp1 = ['', '', '', '', '', ''];
    this.abhaotp2 = ['', '', '', '', '', ''];
    this.abhaSlots = ['', '', ''];
    this.abhaSlots1 = ['', '', ''];
    this.stepper.reset();
    this.stepper.selectedIndex = 0;
    this.generatepublickey();
    this.generateMultiplication();
  }

  //geterate public key for adhar encryption
  generatepublickey() {
    this.registerService.Getautpublickey().subscribe((x: any) => {
      this.abhaidobject.publickey = x.publicKey;
    }, err => {
      console.log(err.error.text);
      this.dashboardService.openSnackBar("Api Failed", "ok")
    });
  }
  respossedata = of({ success: true });
  async gernerateOTP(stepper: MatStepper, type) {
    if (String(this.abhaidobject.adharno).length == 12) {
      if (this.abhaidobject.isagree) {
        if ((this.abhaidobject.iscaptch != null && this.abhaidobject.iscaptch != undefined && this.abhaidobject.iscaptch != '')|| type == 1) {
          // if (Number(this.abhaidobject.iscaptch) == Number(this.product)) {
          let payload = {
            "ci": this.abhaidobject.ci,
            "cAns": this.abhaidobject.iscaptch
          }
          this.open_loader_Dialog();
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.adharno, this.abhaidobject.publickey);

          (type == 0 ? this.registerService.geteratevalidate(payload) : this.respossedata).subscribe((item: any) => {
            if (item.success == true || type == 1) {
              try {
                if (encryptdata) {
                  let payload = {
                    "txnId": "", "scope": [
                      "abha-enrol"
                    ],
                    "loginHint": "aadhaar",
                    "loginId": encryptdata,
                    "otpSystem": "aadhaar"
                  }
                  this.registerService.getabhaidotp(payload).subscribe((data: any) => {
                    this.dialog.closeAll();
                    if (data.txnId) {
                      this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                      this.abhaidobject.message = data.message;
                      if (type == 0) {
                        stepper.next();

                      }
                      this.rsaEncryptionService.resetTimer();
                    } else {
                      this.dashboardService.openSnackBar(data.message, "ok")
                    }

                  }, (err: any) => {
                    debugger
                    this.dialog.closeAll();
                    this.generateMultiplication();
                    if (err.status == 400) {
                      this.dashboardService.openSnackBar("Please enter correct Aadhaar Number.", "ok")
                    } else {

                      if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 422 || err.status == 429) {
                        let errorMessage = "Something went wrong!";
  
                        try {
                          if (typeof err.error === "string") {
                            const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                            if (errorObj.error && errorObj.error.message) {
                              if(errorObj.error.code =='ABDM-1204'){
                                errorMessage = 'Aadhaar number is incorrect. Resident shall use correct Aadhaar.';
                              }else{
                                errorMessage = errorObj.error.message;
                              }
                            
                            }else if (errorObj.loginId) {
                              errorMessage = 'Please enter valid Aadhaar number';
                            } 
                          }
                        } catch (e) {
                          console.error("Error parsing response:", e);
                        }
  
                        this.dashboardService.openSnackBar(errorMessage, "ok");
                      } else {
                        this.dashboardService.openSnackBar(err.statusText, "ok")
                      }
                    }


                  });
                }

              } catch (error) {
                this.dialog.closeAll();
                this.generateMultiplication();
                this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
              }
            } else {
              this.dialog.closeAll();
              this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
            }
          }, err => {
            this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
            this.dialog.closeAll();
          })
        } else {
          this.dashboardService.openSnackBar("Please enter captcha", "ok")
        }
      } else {
        this.dashboardService.openSnackBar("Please provide consent by clicking on 'I agree'", "ok")
      }
    } else {
      this.dashboardService.openSnackBar("Please enter a valid Aadhaar number.", "ok")
    }
  }
  validatemobilenumber(number:any){
    const INDIAN_MOBILE_REGEX = /^(\[\-\s]?)?[6-9]\d{9}$/;
    return INDIAN_MOBILE_REGEX.test(number);
  }
  abhaprofiledetail: AadhaarprofileModel = {}
  async optnumberverifybyadhar(stepper: MatStepper) {
   
    if (String(this.abhaidobject.verifyotpno).length == 6) {
      const checkmob =this.validatemobilenumber(this.abhaidobject.mobileno);
      if (String(this.abhaidobject.mobileno).length == 10 && checkmob) {
        this.open_loader_Dialog();
        try {
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.verifyotpno, this.abhaidobject.publickey);
          if (encryptdata && this.abhaidobject.txnId) {
            let payload = {
              "authData": {
                "authMethods": [
                  "otp"
                ],
                "otp": {
                  // "txnId": this.abhaidobject.txnId,
                  "otpValue": encryptdata,
                  "mobile": this.abhaidobject.mobileno
                }
              },
              "consent": {
                "code": "abha-enrollment",
                "version": "1.4"
              }
            }
            this.registerService.getoptverifybyadharmobileno(payload).subscribe((data: any) => {
              debugger
              this.abhaotp = ['', '', '', '', '', ''];
              this.abhaidobject.verifyotpno = null;
              if (!data.isNew) {
                this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                this.abhaidobject.message = data.message;
                this.abhaidobject.isNew = data.isNew;
                this.rsaEncryptionService.timer = 0;
                this.abhaprofiledetail = data.ABHAProfile;
                if (this.abhaprofiledetail.mobile == this.abhaidobject.mobileno) {
                  this.idexistsModal();
                  this.dialog.closeAll();
                } else {
                  this.verifyresendOTP(0);
                }

              } else if(data.isNew) {
                this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                this.abhaidobject.message = data.message;
                this.abhaidobject.isNew = data.isNew;
                this.rsaEncryptionService.timer = 0;
                this.abhaprofiledetail = data;
                if (this.abhaprofiledetail.mobile == this.abhaidobject.mobileno) {
                  this.idexistsModal();
                  this.dialog.closeAll();
                } else {
                  this.verifyresendOTP(0);
                }
              }else{
                this.dialog.closeAll();
                this.dashboardService.openSnackBar('Something Went wrong', "ok")
              }

            }, err => {
             
              this.dialog.closeAll();
              let errorMessage = "Something went wrong!";
              if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400 || err.status == 422 || err.status == 429) {
              try {
                if (typeof err.error === "string") {
                  const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                  if (errorObj.error && errorObj.error.message) {
                    if(errorObj.error.code=='ABDM-1204'){
                      errorMessage='Please enter Valid OTP';
                    }else{
                      errorMessage = errorObj.error.message;
                    }
                  
                  }
                }
                this.dashboardService.openSnackBar(errorMessage, "ok")
              } catch (e) {
                console.error("Error parsing response:", e);
              }
             } else {
                this.dashboardService.openSnackBar(err.statusText, "ok")
              }

            })
          }

        } catch (error) {
          this.dialog.closeAll();
          this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
        }
      } else {
        this.dashboardService.openSnackBar("Please enter a valid mobile number.", "ok")
      }
    } else {
      this.dashboardService.openSnackBar("Please enter valid OTP number.", "ok")
    }
  }
  // Verify Mobile no with OTP
  async verifyresendOTP(type) {

    const checkmob =this.validatemobilenumber(this.abhaidobject.mobileno);
      if (String(this.abhaidobject.mobileno).length == 10 && checkmob) {
      try {
        this.abhaotp1 = ['', '', '', '', '', ''];
        this.abhaidobject.verifyotpno = null;
        const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.mobileno, this.abhaidobject.publickey);
        if (encryptdata && this.abhaidobject.txnId) {
          let payload = {
            "scope": [
              "abha-profile",
              "mobile-verify"
            ],
            "loginHint": "mobile",
            "loginId": encryptdata,
            "otpSystem": "abdm"
          }
          
          this.registerService.aadhardatafatchotp(payload).subscribe((data: any) => {

            this.dialog.closeAll();
            if (data.txnId) {
              this.abhaidobject.txnId = data.txnId ? data.txnId : null;
              this.abhaidobject.message = data.message;
              this.rsaEncryptionService.resetTimer();
              this.abhaidobject.verifyotpno = null;
              if (type == 0) {
                this.openotpModal();
              }

            } else {
              this.dialog.closeAll();
              this.dashboardService.openSnackBar(data.message, "ok")
            }

          }, err => {
            this.dialog.closeAll();
            if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400 || err.status == 422 || err.status == 429) {
              let errorMessage = "Something went wrong!";

              try {
                if (typeof err.error === "string") {
                  const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                  if (errorObj.error && errorObj.error.message) {
                    errorMessage = errorObj.error.message;
                  } else if (errorObj.loginId) {
                    errorMessage = 'Please enter valid mobile number';
                  }
                }
              } catch (e) {
                console.error("Error parsing response:", e);
              }

              this.dashboardService.openSnackBar(errorMessage, "ok");
            } else {
              this.dashboardService.openSnackBar(err.statusText, "ok")
            }
           

          })
        }

      } catch (error) {
        this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
      }
    } else {
      this.dashboardService.openSnackBar("Please enter valid mobile number.", "ok")
    }
  }
  async againveryOpt() {
    if (String(this.abhaidobject.verifyotpno).length == 6) {
      try {
        const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.verifyotpno, this.abhaidobject.publickey);
        if (encryptdata && this.abhaidobject.txnId) {
          let payload = {
            "scope": [
              "abha-profile",
              "mobile-verify"
            ],
            "authData": {
              "authMethods": [
                "otp"
              ],
              "otp": {
                // "txnId": this.abhaidobject.txnId,
                "otpValue": encryptdata,
              }
            }
          }
          this.registerService.getdirectgov(payload).subscribe((data: any) => {
            this.dialog.closeAll();
            if (data.accounts.length > 0) {
              this.abhaidobject.txnId = data.txnId ? data.txnId : null;
              this.abhaidobject.message = data.message;
              this.abhaidobject.verifyotpno = null;
              this.idexistsModal();
            } else {
              this.dashboardService.openSnackBar(data.message, "ok")
            }

          }, err => {
            this.dialog.closeAll();
            this.dashboardService.openSnackBar(err.statusText, "ok")

          })
        }

      } catch (error) {
        this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
      }
    } else {
      this.dashboardService.openSnackBar("Please enter valid OTP.", "ok")
    }
  }

 
  generateMultiplication() {
    this.abhaidobject.iscaptch = null;
    this.registerService.geterateCaptcha().subscribe((item: any) => {
      this.abhaidobject.cf = 'data:image/jpeg;base64,' + item.cf;
      this.abhaidobject.ci = item.ci;

    });
  }
  closeAbhaDetailsModal() {
    this.abhaidobject = {};
    this.abhaprofiledetail = {};
    this.abhaotp = ['', '', '', '', '', ''];
    this.abhaotp1 = ['', '', '', '', '', ''];
    this.abhaotp2 = ['', '', '', '', '', ''];
    this.abhaotp3 = ['', '', '', '', '', ''];
    this.abhaotp4 = ['', '', '', '', '', ''];
    this.abhaSlots = ['', '', ''];
    this.abhaSlots1 = ['', '', ''];
    this.abhanumber = ['', '', '', '', ''];
    this.storetype = -1;
    this.messagetype = '';
    this.stepper.reset();
    this.stepper.selectedIndex = 0;
    document.getElementById('abhaDetailsModal').style.display = 'none';
  }

  createSuccessfullyModal() {
    document.getElementById('createSuccessfullyModal').style.display = 'block';
  }
  closeCreateSuccessfullyModal(type) {

    document.getElementById('createSuccessfullyModal').style.display = 'none';
  }
  showPassword: boolean = false;
  currentStep = 'form';
  currentStep1 = 'form1';
  currentStep2 = 'form2';
  openfetchabhaModal() {
    this.cleardata();
    setTimeout(() => {
      this.defaultmobileRef.nativeElement.focus();
    });

    this.generateMultiplication();
    this.generatepublickey();
    document.getElementById('fetchabhaModal').style.display = 'block';
    document.getElementById('abhaModal').style.display = 'none';
  }
  closefetchabhaModal() {
    document.getElementById('fetchabhaModal').style.display = 'none';
    this.cleardata();
  }
  cleardata() {
    this.abhaidobject.adharno = null;
    this.abhaidobject.iscaptch = null;
    this.abhaidobject.isagree = false;
    this.abhaprofiledetail = {};
    this.abhaotp = ['', '', '', '', '', ''];
    this.abhaotp1 = ['', '', '', '', '', ''];
    this.abhaotp2 = ['', '', '', '', '', ''];
    this.abhaotp3 = ['', '', '', '', '', ''];
    this.abhaotp4 = ['', '', '', '', '', ''];
    this.abhanumber = ['', '', '', '', ''];
    this.abhaSlots = ['', '', ''];
    this.abhaSlots1 = ['', '', ''];
    this.stepper.reset();
    this.stepper.selectedIndex = 0;
    this.currentStep = 'form';
    this.currentStep1 = 'form1';
    this.currentStep2 = 'form2';
    this.storetype = -1;
    this.messagetype = '';
  }
  showHidePassword() {
    this.showPassword = !this.showPassword;
  }
  onTabChanged(tabChangeEvent: MatTabChangeEvent) {
   
    if (tabChangeEvent.index == 0) {
      this.abhaidobject.mobileno = null;
      setTimeout(() => {
        this.abhaidobject.iscaptch=null;
        this.defaultmobileRef.nativeElement.focus();
      }, 300);

    } else if (tabChangeEvent.index == 1) {
      setTimeout(() => {
        this.abhaidobject.iscaptch=null;
        this.defaultadharRef.nativeElement.focus();
      }, 300);

    } else if (tabChangeEvent.index == 2) {
      setTimeout(() => {
        this.abhaidobject.iscaptch=null;
        this.defaultabhaidRef.nativeElement.focus();
      }, 300);

    }
    this.cleardata();
    this.generateMultiplication();
    this.generatepublickey();
  }
  async nextStep(type) {

    if (this.currentStep === 'form' || type == 1) {
      if (this.abhaidobject.mobileno) {
        if (String(this.abhaidobject.mobileno).length == 10) {
          if ((this.abhaidobject.iscaptch != null && this.abhaidobject.iscaptch != undefined && this.abhaidobject.iscaptch != '') || type == 1) {
            //  if (Number(this.abhaidobject.iscaptch) == Number(this.product)) {
            let payload = {
              "ci": this.abhaidobject.ci,
              "cAns": this.abhaidobject.iscaptch
            }
            this.open_loader_Dialog();
            const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.mobileno, this.abhaidobject.publickey);
            (type == 0 ? this.registerService.geteratevalidate(payload) : this.respossedata).subscribe((item: any) => {
              if (item.success == true || type == 1) {
                try {
                  this.abhaidobject.verifyotpno = null;
                  if (encryptdata) {

                    let payload = {
                      "scope": [
                        "abha-login",
                        "mobile-verify"
                      ],
                      "loginHint": "mobile",
                      "loginId": encryptdata,
                      "otpSystem": "abdm"
                    }
                    this.registerService.mobiledatafatchotp(payload).subscribe((data: any) => {

                      this.dialog.closeAll();
                      if (data.txnId) {
                        this.currentStep = 'otp';
                        this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                        this.abhaidobject.message = data.message;
                        this.rsaEncryptionService.resetTimer();
                        this.abhaidobject.verifyotpno = null;

                      } else {
                        this.dialog.closeAll();
                        this.generateMultiplication();
                        this.dashboardService.openSnackBar(data.message, "ok")
                      }

                    }, err => {
                      this.dialog.closeAll();
                      this.generateMultiplication();
                      if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400 || err.status == 422) {
                        let errorMessage = "Something went wrong!";

                        try {
                          if (typeof err.error === "string") {
                            const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                            if (errorObj.error && errorObj.error.message) {
                              errorMessage = errorObj.error.message;
                            } else if (errorObj.loginId) {
                              errorMessage = 'Please enter valid mobile number';
                            }
                          }
                        } catch (e) {
                          console.error("Error parsing response:", e);
                        }

                        this.dashboardService.openSnackBar(errorMessage, "ok");
                      } else {
                        this.dashboardService.openSnackBar(err.statusText, "ok")
                      }

                    })


                  }

                } catch (error) {
                  this.generateMultiplication();
                  this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
                }
              } else {
                this.dialog.closeAll();
                this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
              }
            }, err => {
              this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
              this.dialog.closeAll();
            })
            // } else {
            //   this.dashboardService.openSnackBar("Please enter a valid captcha result. Entered captcha result is.", "ok")
            // }
          } else {
            this.dashboardService.openSnackBar("Please enter captcha", "ok")
          }
        } else {
          this.dashboardService.openSnackBar("Please enter valid mobile number.", "ok")
        }
      } else {
        this.dashboardService.openSnackBar("Please enter Mobile number.", "ok")
      }

    } else if (this.currentStep === 'otp') {
      if (String(this.abhaidobject.verifyotpno).length == 6) {
        this.open_loader_Dialog();
        try {
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.verifyotpno, this.abhaidobject.publickey);
          if (encryptdata && this.abhaidobject.txnId) {
            let payload = {
              "scope": [
                "abha-login",
                "mobile-verify"
              ],
              "authData": {
                "authMethods": [
                  "otp"
                ],
                "otp": {
                  // "txnId": this.abhaidobject.txnId,
                  "otpValue": encryptdata,
                }
              }

            }
            this.registerService.mobiledatafatchotpverify(payload).subscribe((data: any) => {
              
              this.abhaotp2 = ['', '', '', '', '', ''];
              this.abhaidobject.verifyotpno = null;
              if (data.accounts.length > 0) {
                if (data.txnId) {
                  this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                  this.abhaidobject.message = data.message;
                  this.abhaidobject.isNew = data.isNew;
                  this.rsaEncryptionService.timer = 0;
                  this.abhaprofiledetail = data.accounts;
                  this.abhaprofiledetail.ABHANumber = this.abhaprofiledetail[0].ABHANumber;
                  let vpayload = {
                    "ABHANumber": this.abhaprofiledetail[0].ABHANumber,
                    // "txnId": this.abhaidobject.txnId
                  }
                  this.registerService.ahbauserverify(vpayload).subscribe((x: any) => {
                    this.registerService.getprofiledata().subscribe((data: any) => {
                      this.abhaprofiledetail = data;
                      this.registerService.getabhacarddownload().subscribe((item: any) => {

                        this.currentStep = 'image';
                        this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
                        this.dialog.closeAll();
                      }, err => {
                        this.dialog.closeAll();
                        this.dashboardService.openSnackBar(err, "ok")

                      })
                    })
                  }, err => {
                    this.dashboardService.openSnackBar(err.Error, "ok")
                    this.dialog.closeAll();
                  })

                } else {
                  this.dialog.closeAll();
                  this.dashboardService.openSnackBar(data.message, "ok")
                }
              } else {
                this.abhaidobject.message = data.message;
                this.dialog.closeAll();
              }

            }, err => {
              this.dialog.closeAll();
              if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400) {
                let errorMessage = "Something went wrong!";

                try {
                  if (typeof err.error === "string") {
                    const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                    if (errorObj.error && errorObj.error.message) {
                      errorMessage = errorObj.error.message;
                    } else if (errorObj.loginId) {
                      errorMessage = 'Please enter valid mobile number';
                    }
                  }
                } catch (e) {
                  console.error("Error parsing response:", e);
                }

                this.dashboardService.openSnackBar(errorMessage, "ok");
              } else {
                this.dashboardService.openSnackBar(err.statusText, "ok")
              }
            })
          }

        } catch (error) {
          this.dialog.closeAll();
          this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
        }

      } else {
        this.dashboardService.openSnackBar("Please enter a valid OTP number.", "ok")
      }


    }
  }
  async nextStep1(type) {

    if (this.currentStep1 === 'form1' || type == 1) {
      if (String(this.abhaidobject.adharno).length == 12) {
        if (this.abhaidobject.isagree) {
          if ((this.abhaidobject.iscaptch != null && this.abhaidobject.iscaptch != undefined && this.abhaidobject.iscaptch != '') || type == 1) {
            // if (Number(this.abhaidobject.iscaptch) == Number(this.product)) {
           
            let payload = {
              "ci": this.abhaidobject.ci,
              "cAns": this.abhaidobject.iscaptch
               }
            const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.adharno, this.abhaidobject.publickey);
            this.open_loader_Dialog();
           (type==0? this.registerService.geteratevalidate(payload):this.respossedata).subscribe((item: any) => {
              if (item.success == true || type == 1) {
                try {

                  if (encryptdata) {
                    let payload = {
                      "scope": [
                        "abha-login",
                        "aadhaar-verify"
                      ],
                      "loginHint": "aadhaar",
                      "loginId": encryptdata,
                      "otpSystem": "aadhaar"
                    }
                    this.registerService.mobiledatafatchotp(payload).subscribe((data: any) => {
                      this.dialog.closeAll();
                      if (data.txnId) {
                        this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                        this.abhaidobject.message = data.message;
                        this.rsaEncryptionService.resetTimer();
                        this.currentStep1 = 'otp1';
                      } else {
                        this.dashboardService.openSnackBar(data.message, "ok")
                        this.generateMultiplication();
                      }

                    }, (err: any) => {
                      this.generateMultiplication();
                      this.dialog.closeAll();
                      if (err.status == 400) {
                        this.dashboardService.openSnackBar("Please enter correct Aadhaar Number.", "ok")
                      } else {

                        if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 422) {
                          let errorMessage = "Something went wrong!";
    
                          try {
                            if (typeof err.error === "string") {
                              const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                              if (errorObj.error && errorObj.error.message) {
                                if(errorObj.error.code =='ABDM-1204'){
                                  errorMessage = 'Aadhaar number is incorrect. Resident shall use correct Aadhaar.';
                                }else{
                                  errorMessage = errorObj.error.message;
                                }
                              
                              } 
                            }
                          } catch (e) {
                            console.error("Error parsing response:", e);
                          }
    
                          this.dashboardService.openSnackBar(errorMessage, "ok");
                        } else {
                          this.dashboardService.openSnackBar(err.statusText, "ok")
                        }
                      }

                    });
                  }

                } catch (error) {
                  this.dialog.closeAll();
                  this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
                }
              } else {
                this.dialog.closeAll();
                this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
              }
            }, err => {
              this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
              this.dialog.closeAll();
            })
            // } else {
            //   this.dashboardService.openSnackBar("Please enter a valid captcha result. Entered captcha result is.", "ok")
            // }
          } else {
            this.dashboardService.openSnackBar(" Please enter captcha answer.", "ok")

          }
        } else {
          this.dashboardService.openSnackBar("Please provide consent by clicking on 'I agree'.", "ok")
        }
      } else {
        this.dashboardService.openSnackBar("Please enter a valid Aadhaar number.", "ok")

      }

    } else if (this.currentStep1 === 'otp1') {
      if (String(this.abhaidobject.verifyotpno).length == 6) {
        this.open_loader_Dialog();
        try {
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.verifyotpno, this.abhaidobject.publickey);
          if (encryptdata && this.abhaidobject.txnId) {
            let payload = {
              "scope": [
                "abha-login",
                "aadhaar-verify"
              ],
              "authData": {
                "authMethods": [
                  "otp"
                ],
                "otp": {
                  // "txnId": this.abhaidobject.txnId,
                  "otpValue": encryptdata,
                }
              }

            }
            this.registerService.mobiledatafatchotpverify(payload).subscribe((data: any) => {

              this.abhaotp3 = ['', '', '', '', '', ''];
              this.abhaidobject.verifyotpno = null;
              if (data.accounts.length > 0) {
                if (data.txnId) {
                  this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                  this.abhaidobject.message = data.message;
                  this.abhaidobject.isNew = data.isNew;
                  this.rsaEncryptionService.timer = 0;
                  this.abhaprofiledetail = data.accounts;
                  this.abhaprofiledetail.ABHANumber = this.abhaprofiledetail[0].ABHANumber;

                  this.registerService.getprofiledata().subscribe((data: any) => {
                    this.abhaprofiledetail = data;

                    this.registerService.getabhacarddownload().subscribe((item: any) => {

                      this.currentStep1 = 'image1';
                      this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
                      this.dialog.closeAll();
                    }, err => {
                      this.dialog.closeAll();
                      this.dashboardService.openSnackBar(err, "ok")

                    })

                  }, err => {
                    this.dashboardService.openSnackBar(err.Error, "ok")
                    this.dialog.closeAll();
                  })

                } else {
                  this.dialog.closeAll();
                  this.dashboardService.openSnackBar(data.message, "ok")
                }
              } else {
                this.abhaidobject.message = data.message;
                this.dialog.closeAll();
              }

            }, err => {
              this.dialog.closeAll();
              if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400) {
                let errorMessage = "Something went wrong!";

                try {
                  if (typeof err.error === "string") {
                    const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                    if (errorObj.error && errorObj.error.message) {
                      errorMessage = errorObj.error.message;
                    } else if (errorObj.loginId) {
                      errorMessage = 'Please enter a valid OTP number';
                    }
                  }
                } catch (e) {
                  console.error("Error parsing response:", e);
                }

                this.dashboardService.openSnackBar(errorMessage, "ok");
              } else {
                this.dashboardService.openSnackBar(err.statusText, "ok")
              }
            })
          }

        } catch (error) {
          this.dialog.closeAll();
          this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
        }

      } else {
        this.dashboardService.openSnackBar("Please enter a valid OTP number.", "ok")
      }

    }
  }
  async nextStep2(type) {

    if (this.currentStep2 === 'form2' || type == 1) {
      if (String(this.abhaprofiledetail.ABHANumber).length == 17) {
        if ((this.abhaidobject.iscaptch != null && this.abhaidobject.iscaptch != undefined && this.abhaidobject.iscaptch != '') || type == 1) {
          //   if (Number(this.abhaidobject.iscaptch) == Number(this.product)) {
          this.open_loader_Dialog();
          this.abhaidobject.verifyotpno = null;
         
          let payload = {
            "ci": this.abhaidobject.ci,
            "cAns": this.abhaidobject.iscaptch
          }
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaprofiledetail.ABHANumber, this.abhaidobject.publickey);
          (type==0? this.registerService.geteratevalidate(payload):this.respossedata).subscribe((item: any) => {
            if (item.success == true || type == 1) {
              try {

                if (encryptdata) {
                  let payload = {
                    "scope": [
                      "abha-login", "mobile-verify"
                    ],
                    "loginHint": "abha-number",
                    "loginId": encryptdata,
                    "otpSystem": "abdm"
                  }

                  this.registerService.mobiledatafatchotp(payload).subscribe((data: any) => {

                    this.dialog.closeAll();
                    if (data.txnId) {
                      this.currentStep2 = 'otp2';
                      this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                      this.abhaidobject.message = data.message;
                      this.rsaEncryptionService.resetTimer();
                      this.abhaidobject.verifyotpno = null;

                    } else {
                      this.dialog.closeAll();
                      this.generateMultiplication();
                      this.dashboardService.openSnackBar(data.message, "ok")
                    }

                  }, err => {
                    this.dialog.closeAll();
                    this.generateMultiplication();
                    if (err.status == 404 || err.status == 401 || err.status == 403 || err.status == 400) {
                      let errorMessage = "Something went wrong!";

                      try {
                        if (typeof err.error === "string") {
                          const errorObj = JSON.parse(err.error.replace("Error: ", "")); // "Error:
                          if (errorObj.error && errorObj.error.message) {
                            errorMessage = errorObj.error.message;
                          } 
                        }
                      } catch (e) {
                        console.error("Error parsing response:", e);
                      }

                      this.dashboardService.openSnackBar(errorMessage, "ok");
                    } else {
                      this.dashboardService.openSnackBar(err.statusText, "ok")
                    }

                  })


                }

              } catch (error) {
                this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
              }
            } else {
              this.dialog.closeAll();
              this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
            }
          }, err => {
            this.dashboardService.openSnackBar("Please enter a valid captcha.", "ok")
            this.dialog.closeAll();
          })
          // } else {
          //   this.dashboardService.openSnackBar("Please enter a valid captcha result. Entered captcha result is.", "ok")
          // }
        } else {
          this.dashboardService.openSnackBar("Please enter captcha answer.", "ok")
        }
      } else {
        this.dashboardService.openSnackBar("Please enter valid ABHAID.", "ok")
      }

    } else if (this.currentStep2 == 'otp2') {
      if (String(this.abhaidobject.verifyotpno).length == 6) {
        try {
          this.open_loader_Dialog();
          const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.verifyotpno, this.abhaidobject.publickey);
          if (encryptdata) {
            let payload = {
              "scope": [
                "abha-login", "mobile-verify"
              ],
              "authData": {
                "authMethods": [
                  "otp"
                ],
                "otp": {
                  // "txnId": this.abhaidobject.txnId,
                  "otpValue": encryptdata
                }
              }
            }

            this.registerService.mobiledatafatchotpverify(payload).subscribe((data: any) => {
              this.abhaotp4 = ['', '', '', '', '', ''];
              this.abhaidobject.verifyotpno = null;
              if(data.authResult =='failed'){
                this.dialog.closeAll();
              }
              if (data.txnId) {
                this.abhaidobject.txnId = data.txnId ? data.txnId : null;
                this.abhaidobject.message = data.message;
                this.rsaEncryptionService.resetTimer();
                this.abhaidobject.verifyotpno = null;
                this.abhaprofiledetail = data.accounts;
                this.abhaprofiledetail.ABHANumber = this.abhaprofiledetail[0].ABHANumber;
                this.registerService.getprofiledata().subscribe((data: any) => {
                  this.abhaprofiledetail = data;
                  this.registerService.getabhacarddownload().subscribe((item: any) => {
                    this.currentStep2 = 'image2';
                    this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
                    this.dialog.closeAll();
                  }, err => {
                    this.dialog.closeAll();
                    this.dashboardService.openSnackBar(err, "ok")

                  })
                }, err => {
                  this.dialog.closeAll();
                  this.dashboardService.openSnackBar(err, "ok")

                })
              } else {
                this.dialog.closeAll();
                this.dashboardService.openSnackBar(data.message, "ok")
              }

            }, err => {
              this.dialog.closeAll();
              this.dashboardService.openSnackBar(err.statusText, "ok")

            })


          }

        } catch (error) {
          this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
        }

      } else {
        this.dashboardService.openSnackBar("Please enter valid OTP.", "ok")
      }

    }
  }
  openotpModal() {
    document.getElementById('otpModal').style.display = 'block';
  }
  closeotpModal() {
    document.getElementById('otpModal').style.display = 'none';
  }
  idexistsModal() {
    document.getElementById('idexistsModal').style.display = 'block';
    document.getElementById('otpModal').style.display = 'none';
  }
  slectdataname(data: any) {
    this.abhaidobject.abhaaddress = data;
  }

  predefineabhaadress: any = [];
  closeidexistsModal(stepper: MatStepper, type) {
    this.open_loader_Dialog();
    if (type == 1) {
      this.registerService.abhaaddresssuggestion().subscribe((data: any) => {
        this.predefineabhaadress = data.abhaAddressList.slice(0, 3);
        this.dialog.closeAll();
        stepper.next();
      }, err => {
        this.dialog.closeAll();
        console.log(err)
      })

    } else {
      // Set to focus on the last step
      this.registerService.getabhacarddownload().subscribe((item: any) => {
        this.dialog.closeAll();
        this.stepper.selectedIndex = this.stepper.steps.length - 1;
        this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
      }, err => {
        this.dialog.closeAll();
        console.log(err)
      })
    }

    document.getElementById('idexistsModal').style.display = 'none';
  }

  profileDATA() {
    this.registerService.getprofiledata().subscribe((item: any) => {
      console.log(item)
    }, err => {

      console.log(err)
    })
  }
  closeabhadetail(type) {
    document.getElementById('updateabhaRecordModal').style.display = 'none';
    if (type == 0) {
      this.closeAbhaDetailsModal();
    } else {
      this.closefetchabhaModal();
    }
  }
  yesAbhadetail(data: any, type) {
    const rdashabhano = data.ABHANumber.replace(/-/g, "");
    this.opdvisitService.patientdetails.firstName = data.firstName;
    this.opdvisitService.patientdetails.lastName = data.lastName;
    this.opdvisitService.patientdetails.abhaID = rdashabhano;
    this.opdvisitService.patientdetails.emailAddress = type == 0 ? data.email : null;
    this.opdvisitService.patientdetails.mobileNo = data.mobile;
    this.opdvisitService.patientdetails.sex = data.gender;
    if (this.opdvisitService.patientdetails.sex.toLowerCase() == 'm') {
      this.opdvisitService.patientdetails.initial = 'Mr.'
    } else {
      this.opdvisitService.patientdetails.initial = 'Miss.'
    }
    this.opdvisitService.patientdetails.paddress = data.address;
    this.opdvisitService.patientdetails.pinCode = type == 0 ? data.pinCode : data.pincode
    this.opdvisitService.countryid = this.returnstateid(data.stateName, 0);
    this.opdvisitService.stateid = this.returnstateid(data.stateName, 1);
    this.returndistrictdata(this.opdvisitService.stateid, data.districtName);
    let formattedDate = type == 0 ? this.convertToValidDate(data.dob) : this.convertToValidDate(data.dayOfBirth + '-' + data.monthOfBirth + '-' + data.yearOfBirth);
    this.opdvisitService.patientdetails.dob = this.datePipe.transform(formattedDate, 'yyyy-MM-dd');
    this.getage(this.opdvisitService.patientdetails.dob);
    this.opdvisitService.agehide = true;
    if (type == 0) {
      this.closeAbhaDetailsModal();
    } else {
      this.closefetchabhaModal();
    }
    document.getElementById('updateabhaRecordModal').style.display = 'none';
  }
  storetype: number = -1;
  messagetype: string = '';
  transferdatatoReg(data: any, type) {
    this.storetype = type;
    if (data.ABHANumber) {
      const rdashabhano = data.ABHANumber.replace(/-/g, "");
      this.opdvisitService.getAllPateintSearch('S', 'AbhaID', rdashabhano, 'ASC').subscribe((item: any) => {
        if (item.length > 0) {
          this.opdvisitService.getpatientdetails(item[0].pkRegId, 0);
          this.messagetype = 'Abha ID already exists. Verify your exists record before proceeding with the update.?'
          document.getElementById('updateabhaRecordModal').style.display = 'block';
          if (type == 0) {
            document.getElementById('abhaDetailsModal').style.display = 'none';
          } else {
            document.getElementById('fetchabhaModal').style.display = 'none';
          }
        } else {
          if (this.opdvisitService.patientdetails.pkRegId > 0) {
            if (this.opdvisitService.patientdetails.firstName.toLowerCase() == data.firstName.toLowerCase() && this.opdvisitService.patientdetails.lastName.toLowerCase() == data.lastName.toLowerCase()) {
              this.messagetype = 'UHID already exists. Verify your exists record before proceeding with the update.?'
            } else {
              this.messagetype = 'UHID already exists. Name mismatch detected. Proceed with update.?'
            }
            if (type == 0) {
              document.getElementById('abhaDetailsModal').style.display = 'none';
            } else {
              document.getElementById('fetchabhaModal').style.display = 'none';
            }
            document.getElementById('updateabhaRecordModal').style.display = 'block';
          } else {
            this.opdvisitService.patientdetails.pkRegId = 0;
            this.opdvisitService.patientdetails.firstName = data.firstName;
            this.opdvisitService.patientdetails.lastName = data.lastName;
            this.opdvisitService.patientdetails.abhaID = rdashabhano;
            this.opdvisitService.patientdetails.emailAddress = type == 0 ? data.email : null;
            this.opdvisitService.patientdetails.mobileNo = data.mobile;
            this.opdvisitService.patientdetails.sex = data.gender;
            if (this.opdvisitService.patientdetails.sex.toLowerCase() == 'm') {
              this.opdvisitService.patientdetails.initial = 'Mr.'
            } else {
              this.opdvisitService.patientdetails.initial = 'Miss.'
            }
            this.opdvisitService.patientdetails.paddress = data.address;
            this.opdvisitService.patientdetails.pinCode = type == 0 ? data.pinCode : data.pincode
            this.opdvisitService.countryid = this.returnstateid(data.stateName, 0);
            this.opdvisitService.stateid = this.returnstateid(data.stateName, 1);
            this.returndistrictdata(this.opdvisitService.stateid, data.districtName);
            let formattedDate = type == 0 ? this.convertToValidDate(data.dob) : this.convertToValidDate(data.dayOfBirth + '-' + data.monthOfBirth + '-' + data.yearOfBirth);
            this.opdvisitService.patientdetails.dob = this.datePipe.transform(formattedDate, 'yyyy-MM-dd');
            this.getage(this.opdvisitService.patientdetails.dob);
            this.opdvisitService.agehide = true;
            if (type == 0) {
              this.closeAbhaDetailsModal();
            } else {
              this.closefetchabhaModal();
            }
          }
        }

      });

    }

    console.log(data)

  }
  convertToValidDate(dateStr: string): string {
    let parts = dateStr.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to YYYY-MM-DD
  }
  returnstateid(statename: any, type) {
    if (type == 0) {
      return this.opdvisitService.states.filter(item => String(item.stateName).toLowerCase() == statename.toLowerCase())[0].fkCountryId;
    } else if (type == 1) {
      return this.opdvisitService.states.filter(item => String(item.stateName).toLowerCase() == statename.toLowerCase())[0].pkStateId;
    }
  }
  returndistrictdata(stateid: any, distictname: any) {
    this.opdvisitService.getdistricts_sameas(stateid).subscribe((item: any) => {
      this.opdvisitService.districts = item;
      this.opdvisitService.districtid = this.opdvisitService.districts.filter(item => String(item.districtname).toLowerCase() == distictname.toLowerCase())[0].pkDistrictId;
      this.getcities(this.opdvisitService.districtid, 1);
    });
  }
  printBase64Image(image: any) {
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>ABHAID CARD</title>
          </head>
          <body onload="window.print(); window.close();">
            <img src="${image}" style="width: 100%; max-width: 800px;" />
          </body>
        </html>
      `);
      newWindow.document.close();
    } else {
      console.error("Popup blocked! Allow pop-ups for this site.");
    }

  }

  // downloadabha(){
  //      this.registerService.getabhacarddownload().subscribe((item: any) => {
  //       console.log(item)
  //     }, err => {

  //       console.log(err)
  //     })
  // }
  validateInputdata(input: string): boolean {
    const allowedCharsRegex = /^[a-zA-Z0-9]+[_][a-zA-Z0-9]|[.][a-zA-Z0-9]+$/;
    return allowedCharsRegex.test(input);
  }
  async updateABHAAddress(stepper: MatStepper) {
  
    const minLength = 8;
    const maxLength = 18;
    if (String(this.abhaidobject.abhaaddress).length < minLength) {
      this.dashboardService.openSnackBar("ABHA Address must be at least 8 characters long.", "ok");
      return;
    }

    if (String(this.abhaidobject.abhaaddress).length > maxLength) {
      this.dashboardService.openSnackBar("ABHA Address cannot exceed 18 characters.", "ok");
      return;
    }
    const checkdotdat = this.validateInputdata(this.abhaidobject.abhaaddress);
    if (!checkdotdat) {
      this.dashboardService.openSnackBar("Only letters, numbers, and at most one dot (.) or underscore (_) in between are allowed.", "ok");
      return;
    }

    if (this.abhaidobject.abhaaddress.startsWith('.') || this.abhaidobject.abhaaddress.startsWith('_') ||
      this.abhaidobject.abhaaddress.endsWith('.') || this.abhaidobject.abhaaddress.endsWith('_')) {
      this.dashboardService.openSnackBar("Special characters cannot be at the start or end.", "ok");
      return;
    }
    if (!this.abhaidobject.abhaaddress) {
      return this.dashboardService.openSnackBar("Please enter ABHA address.", "ok");
    }
    //   if (String(this.abhaidobject.abhaaddress).length >= 8 || String(this.abhaidobject.abhaaddress).length <= 18) {
    try {
      //   const encryptdata = await this.rsaEncryptionService.encryptAadhaar(this.abhaidobject.abhaaddress, this.abhaidobject.publickey);
    //  if (this.abhaidobject.txnId) {
        this.open_loader_Dialog();
        let payload = {
          // "txnId": this.abhaidobject.txnId,
          "abhaAddress": this.abhaidobject.abhaaddress,
          "preferred": 1
        }
        this.registerService.updateABHAaddress(payload).subscribe((data: any) => {
         
          if (data.txnId) {
            this.abhaidobject.txnId = data.txnId ? data.txnId : null;
            this.abhaidobject.abhaaddress = data.abhaAddress;
            this.abhaidobject.verifyotpno = null;
            this.registerService.getabhacarddownload().subscribe((item: any) => {
              this.dialog.closeAll();
              this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
              stepper.next();
            }, err => {
              this.dialog.closeAll();
              console.log(err)
            })

          } else {
            this.dialog.closeAll();
            this.dashboardService.openSnackBar(data.message, "ok")
          }

        }, err => {
          this.dialog.closeAll();
          this.dashboardService.openSnackBar(err.Error.abhaAddress, "ok")

        })
    //  }

    } catch (error) {
      this.dashboardService.openSnackBar("Encryption error. " + error, "ok")
    }
    // } else {
    //   this.dashboardService.openSnackBar("Address length must be between 8 (min) and 18 (max) characters.", "ok")
    // }

  }
  skipaddress(stepper: MatStepper) {
    this.registerService.getabhacarddownload().subscribe((item: any) => {
      this.abhaprofiledetail.photo = 'data:image/jpeg;base64,' + item.imageB64;
      stepper.next();
    }, err => {

      console.log(err)
    })

  }
  async downloadPdf() {
    try {
      const pdf = new jsPDF();
      const imgProps = await this.getImageDimensions(this.abhaprofiledetail.photo);

      // Calculate dimensions to fit A4 page
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pageWidth / imgProps.width, pageHeight / imgProps.height);

      pdf.addImage(
        this.abhaprofiledetail.photo,
        'JPEG', // or 'PNG' depending on image type
        (pageWidth - imgProps.width * ratio) / 2, // x position (centered)
        (pageHeight - imgProps.height * ratio) / 2, // y position (centered)
        imgProps.width * ratio,
        imgProps.height * ratio
      );
      let downloadname = 'ABHA-' + this.abhaprofiledetail.ABHANumber + '.pdf'
      pdf.save(downloadname);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }

  private getImageDimensions(base64: string): Promise<{ width: number, height: number }> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };
    });
  }
  //get and insert/update record
  // getupdateandsamereceod(data:any){
  //   const rdashabhano = data.ABHANumber.replace(/-/g, "");
  //   this.registerService.getabhadetailbyabhaid(rdashabhano).subscribe((x:any)=>{

  //       let payload={
  //           "pk_TranId": x.pk_TranId >0 ? x.pk_TranId : 0,
  //           "aadharCardNo": this.abhaidobject.adharno,
  //           "abhaID": data.ABHANumber,
  //           "isAbhaConsentTaken": this.abhaidobject.isagree,
  //           "firstName": data.firstName,
  //           "middleName": data.middleName,
  //           "lastName": data.lastName,
  //           "dob": data.dob,
  //           "gender": data.gender,
  //           "mobile": data.mobile,
  //           "mobileVerified":  data.mobileVerified,
  //           "email": data.email,
  //           "phrAddress": data.phrAddress,
  //           "address": data.address,
  //           "districtCode": data.districtCode,
  //           "stateCode": data.stateCode,
  //           "pinCode": data.pinCode,
  //           "abhaType": data.abhaType,
  //           "stateName":data.stateName,
  //           "districtName": data.districtName,
  //           "abhaNumber": data.abhaNumber,
  //           "abhaStatus": "ACTIVE",
  //           "isNew": false,

  //       }
  //       this.registerService.saveabhadetail(payload).subscribe((data:any)=>{

  //       })

  //   });
  // }

}

